{
 "@catalog/Build": "Build",
 "@catalog/Build/Windows and Doors": "Windows and Doors",
 "@catalog/Build/Windows and Doors/Doors": "Doors",
 "@catalog/Build/Windows and Doors/Doors#Single Doors": "Single Doors",
 "@catalog/Build/Windows and Doors/Doors#Double Doors": "Double Doors",
 "@catalog/Build/Windows and Doors/Doors#Arch Doors": "Arch Doors",
 "@catalog/Build/Windows and Doors/Doors#Entry Doors": "Entry Doors",
 "@catalog/Build/Windows and Doors/Doors#Entrance set": "Entrance Set",
 "@catalog/Build/Windows and Doors/Doors#Sliding Doors": "Sliding Doors",
 "@catalog/Build/Windows and Doors/Doors#Folding Doors": "Folding Doors",
 "@catalog/Build/Windows and Doors/Doors#Balcony Doors": "Balcony Doors",
 "@catalog/Build/Windows and Doors/Doors#Special Doors": "Special Doors",
 "@catalog/Build/Windows and Doors/Windows": "Windows",
 "@catalog/Build/Windows and Doors/Arches": "Arches",
 "@catalog/Build/Windows and Doors/CeilingCurtains": "Ceiling Curtain",
 "@catalog/Build/Windows and Doors/Curtains": "Curtains",
 "@catalog/Build/Windows and Doors/Openings": "Openings",
 "@catalog/Build/Windows and Doors/Garage Doors": "Garage Doors",
 "@catalog/Build/Windows and Doors/Skylight": "Skylight Window",
 "@catalog/Build/Windows and Doors/Shutters": "Shutters",
 "@catalog/Build/Windows and Doors/Window sills": "Window Sills",
 "@catalog/Build/Windows and Doors/Elevator": "Elevator",
 "@catalog/Build/Constructions": "Constructions",
 "@catalog/Build/Constructions/Primitives": "Primitives",
 "@catalog/Build/Constructions/Interior Wall": "Wall",
 "@catalog/Build/Constructions/CeilingDecor": "Ceiling Constructions",
 "@catalog/Build/Constructions/Wall constructions": "Wall Constructions",
 "@catalog/Build/Constructions/Moldings": "Moldings",
 "@catalog/Build/Constructions/Columns": "Columns",
 "@catalog/Build/Constructions/Stucco": "Stucco",
 "@catalog/Build/Constructions/Pipes": "Pipes",
 "@catalog/Build/Materials": "Materials",
 "@catalog/Build/Materials/Other": "Other",
 "@catalog/Build/Materials/Wood": "Wood",
 "@catalog/Build/Materials/Marble": "Marble",
 "@catalog/Build/Materials/Tile": "Tile",
 "@catalog/Build/Materials/Slats": "Slats",
 "@catalog/Build/Materials/Fabric": "Fabric",
 "@catalog/Build/Materials/Wallpapers": "Wallpaper",
 "@catalog/Build/Materials/Finishes": "Finishes",
 "@catalog/Build/Materials/Paneling": "Paneling",
 "@catalog/Build/Materials/Parquet or Laminate": "Parquet, Laminate",
 "@catalog/Build/Materials/Glass": "Glass",
 "@catalog/Build/Materials/Stone": "Stone",
 "@catalog/Build/Materials/Bricks": "Bricks",
 "@catalog/Build/Materials/Carpet": "Carpet",
 "@catalog/Build/Materials/MaterialPlants": "Plants",
 "@catalog/Build/Materials/Metal": "Metal",
 "@catalog/Build/Materials/Photo Wallpaper": "Photo Wallpapers",
 "@catalog/Build/Materials/Ground": "Ground",
 "@catalog/Build/Materials/Granite": "Granite",
 "@catalog/Build/Materials/Neon": "Neon",
 "@catalog/Build/Materials/Water": "Water",
 "@catalog/Build/Materials/Sky": "Sky",
 "@catalog/Build/Materials/Rattan": "Rattan",
 "@catalog/Build/Materials/Leather": "Leather",
 "@catalog/Build/Materials/Roof": "Roof",
 "@catalog/Build/Materials/Colors": "Colors",
 "@catalog/Build/Stairs": "Stairs",
 "@catalog/Build/Stairs#Steps": "Steps",
 "@catalog/Build/Stairs#Straight Stairs": "Straight stairs",
 "@catalog/Build/Stairs#L-shape Stairs": "L-shape stairs",
 "@catalog/Build/Stairs#U-shape Stairs": "U-shape stairs",
 "@catalog/Build/Stairs#Spiral Stairs": "Spiral stairs",
 "@catalog/Build/Stairs#Curved Stairs": "Curved stairs",
 "@catalog/Build/Stairs#Winder Stairs": "Winder stairs",
 "@catalog/Build/Stairs#Grand Staircase": "Grand stairs",
 "@catalog/Build/Stairs#Ladder": "Ladder",
 "@catalog/Build/Stairs#Task Stairs": "Task stairs",
 "@catalog/Build/Stairs#Railing": "Railing",
 "@catalog/Build/Climate electronics": "Climate Electronics",
 "@catalog/Build/Climate electronics/Conditioner": "Conditioner",
 "@catalog/Build/Climate electronics/Ceiling fan": "Ceiling Fan",
 "@catalog/Build/Climate electronics/Heating": "Heating",
 "@catalog/Build/Climate electronics/Ventilation": "Ventilation",
 "@catalog/Build/Climate electronics/Fan": "Fan",
 "@catalog/Build/Climate electronics/Air purifier": "Air Purifier",
 "@catalog/Build/Climate electronics/Water heater": "Water Heater",
 "@catalog/Build/Climate electronics/Thermometer": "Thermometer",
 "@catalog/Build/Electricity": "Electricity",
 "@catalog/Build/Electricity/LightingOutletsSwitches": "Outlets, Switches",
 "@catalog/Build/Electricity/Electricity supplies": "Electricity Supplies",
 "@catalog/Build/Fireplaces": "Fireplaces",
 "@catalog/Build/Fireplaces#Traditional Fireplace": "Traditional Fireplace",
 "@catalog/Build/Fireplaces#Modern Fireplace": "Modern Fireplace",
 "@catalog/Build/Fireplaces#Stove Fireplace": "Stove Fireplace",
 "@catalog/Build/Fireplaces#Freestanding Fireplace": "Freestanding Fireplace",
 "@catalog/Build/Fireplaces#Suspended Fireplace": "Suspended Fireplace",
 "@catalog/Build/Fireplaces#Fireplace Accessories": "Fireplace Accessories",
 "@catalog/Build/Roofs": "Roofs",
 "@catalog/Build/Roofs/Roof types": "Roof Types",
 "@catalog/Build/Roofs/Dormer window": "Dormer Window",
 "@catalog/Build/Roofs/Chimney": "Chimney",
 "@catalog/Build/Roofs/Gutter": "Gutter",
 "@catalog/Build/Knobs,handles": "Knobs,Handles",
 "@catalog/Other Rooms": "By room type",
 "@catalog/Other Rooms/kids": "Baby & Kids",
 "@catalog/Other Rooms/kids/KidBed": "Junior Bed",
 "@catalog/Other Rooms/kids/Kids Storage": "Kids Storage",
 "@catalog/Other Rooms/kids/Baby Gear": "Baby Gear",
 "@catalog/Other Rooms/kids/Baby Gear/Kids Decor": "Children's Decor",
 "@catalog/Other Rooms/kids/Baby Gear/Kids Decor/Toys": "Toys",
 "@catalog/Other Rooms/kids/Baby Gear/Kids Decor/KidsDecor": "Kids' decor",
 "@catalog/Other Rooms/kids/Baby Gear/Kids Decor/Kids Art": "Kids Wall Art",
 "@catalog/Other Rooms/kids/Baby Gear/Kids Decor/Kids Rugs": "Kids Rugs",
 "@catalog/Other Rooms/kids/Baby Gear/Kids Decor/Play Tents": "Play Tents",
 "@catalog/Other Rooms/kids/Baby Gear/Crib": "Crib",
 "@catalog/Other Rooms/kids/Baby Gear/Kid Lamp": "Kid Lamp",
 "@catalog/Other Rooms/kids/Baby Gear/Bed Canopy": "Bed Canopy",
 "@catalog/Other Rooms/kids/Baby Gear/High Chair": "High Chair",
 "@catalog/Other Rooms/kids/Baby Gear/Play Tents": "Play Tents",
 "@catalog/Other Rooms/kids/Baby Gear/Changing Table": "Changing Table",
 "@catalog/Other Rooms/kids/Kid Lamp": "Kid Lamp",
 "@catalog/Other Rooms/kids/Kids tables and chairs": "Kids tables and chairs",
 "@catalog/Other Rooms/Laundry and cleaning": "Laundry and Cleaning",
 "@catalog/Other Rooms/Laundry and cleaning/Washers / Dryers": "Washers / Dryers",
 "@catalog/Other Rooms/Laundry and cleaning/Laundry accessories": "Laundry Accessories",
 "@catalog/Other Rooms/Laundry and cleaning/Vacuum cleaners and mops": "Vacuum Cleaners and Mops",
 "@catalog/Other Rooms/Laundry and cleaning/Cleaning": "Cleaning",
 "@catalog/Other Rooms/Laundry and cleaning/Irons and Steamers": "Irons and Steamers",
 "@catalog/Other Rooms/Fireplaces": "Fireplaces",
 "@catalog/Other Rooms/bathroom": "Bathroom",
 "@catalog/Other Rooms/bathroom/Bath and Spa": "Bath and Spa",
 "@catalog/Other Rooms/bathroom/Bath and Spa/Shower": "Shower",
 "@catalog/Other Rooms/bathroom/Bath and Spa/Shower#Shower Cabin": "Shower Cabin",
 "@catalog/Other Rooms/bathroom/Bath and Spa/Shower#Shower System": "Shower System",
 "@catalog/Other Rooms/bathroom/Bath and Spa/Shower#ShowerMixer": "ShowerMixer",
 "@catalog/Other Rooms/bathroom/Bath and Spa/Shower#ShowerScreen": "ShowerScreen",
 "@catalog/Other Rooms/bathroom/Bath and Spa/Shower#ShowerTray": "ShowerTray",
 "@catalog/Other Rooms/bathroom/Bath and Spa/Bath": "Bath",
 "@catalog/Other Rooms/bathroom/Bath and Spa/Bath#SingleBath": "SingleBath",
 "@catalog/Other Rooms/bathroom/Bath and Spa/Bath#Bath Faucet": "Bath Faucet",
 "@catalog/Other Rooms/bathroom/Bath and Spa/Bath#Jacuzzi": "Jacuzzi",
 "@catalog/Other Rooms/bathroom/Bath and Spa/Spa": "Spa",
 "@catalog/Other Rooms/bathroom/Bath and Spa/Sauna": "Sauna",
 "@catalog/Other Rooms/bathroom/Bath Accessories": "Bathroom Accessories",
 "@catalog/Other Rooms/bathroom/Bath Accessories/Towel rack": "Towel Rack",
 "@catalog/Other Rooms/bathroom/Bath Accessories/Bathroom Decor": "Bathroom Decor",
 "@catalog/Other Rooms/bathroom/Bath Accessories/Soap and shampoo": "Soap and Shampoo",
 "@catalog/Other Rooms/bathroom/Bath Accessories/Toilet Paper Holder": "Toilet Paper Holder",
 "@catalog/Other Rooms/bathroom/Bath Accessories/Cosmetics": "Cosmetics",
 "@catalog/Other Rooms/bathroom/Bath Accessories/Toilet Brush": "Toilet Brush",
 "@catalog/Other Rooms/bathroom/Bath Accessories/Toothbrush holder": "Toothbrush holder",
 "@catalog/Other Rooms/bathroom/Bath Accessories/Safety rack": "Safety rack",
 "@catalog/Other Rooms/bathroom/Bath Accessories/Toilet Seat": "Toilet Seat",
 "@catalog/Other Rooms/bathroom/Bath Accessories/Hair Dryers": "Hair Dryers",
 "@catalog/Other Rooms/bathroom/Bath Accessories/Hand Dryers": "Hand Dryers",
 "@catalog/Other Rooms/bathroom/Lavatory pan": "Lavatory Pan",
 "@catalog/Other Rooms/bathroom/Lavatory pan#Toilet": "Toilet",
 "@catalog/Other Rooms/bathroom/Lavatory pan#Wall-mounted Toilet": "Wall-mounted Toilet",
 "@catalog/Other Rooms/bathroom/Lavatory pan#Flush": "Flush",
 "@catalog/Other Rooms/bathroom/Lavatory pan#Urinal": "Urinal",
 "@catalog/Other Rooms/bathroom/Lavatory pan#Bidet": "Bidet",
 "@catalog/Other Rooms/bathroom/Lavatory pan#Floor Toilet": "Floor Toilet",
 "@catalog/Other Rooms/bathroom/Lavatory pan#Kid Toilet": "Kid Toilet",
 "@catalog/Other Rooms/outdoor": "Yard or Patio",
 "@catalog/Other Rooms/outdoor/Swimming pool": "Swimming Pool",
 "@catalog/Other Rooms/outdoor/Swimming pool/Swimming pool": "Swimming Pool",
 "@catalog/Other Rooms/outdoor/Swimming pool/Sunbed": "Sunbed",
 "@catalog/Other Rooms/outdoor/Swimming pool/Umbrella": "Umbrella",
 "@catalog/Other Rooms/outdoor/Swimming pool/Pool Accessories": "Pool Accessories",
 "@catalog/Other Rooms/outdoor/Garden Structures": "Garden Structures",
 "@catalog/Other Rooms/outdoor/Garden Structures/Fences": "Fences",
 "@catalog/Other Rooms/outdoor/Garden Structures/Fences#Fence": "Fence",
 "@catalog/Other Rooms/outdoor/Garden Structures/Fences#Gate": "Gate",
 "@catalog/Other Rooms/outdoor/Garden Structures/Balcony": "Balcony",
 "@catalog/Other Rooms/outdoor/Garden Structures/Umbrella": "Umbrella",
 "@catalog/Other Rooms/outdoor/Garden Structures/Gazebo": "Gazebo",
 "@catalog/Other Rooms/outdoor/Garden Structures/Canopies": "Canopies",
 "@catalog/Other Rooms/outdoor/Garden Structures/Porch": "Porch",
 "@catalog/Other Rooms/outdoor/Garden Structures/Sunhouse": "Sunhouse",
 "@catalog/Other Rooms/outdoor/Landscaping": "Landscaping",
 "@catalog/Other Rooms/outdoor/Landscaping/Flowers": "Flowers",
 "@catalog/Other Rooms/outdoor/Landscaping/Phytowall": "Phytowall",
 "@catalog/Other Rooms/outdoor/Landscaping/Outdoor plants": "Outdoor Plants",
 "@catalog/Other Rooms/outdoor/Landscaping/Trees": "Trees",
 "@catalog/Other Rooms/outdoor/Landscaping/Bushes": "Bushes",
 "@catalog/Other Rooms/outdoor/Landscaping/Roads": "Roads",
 "@catalog/Other Rooms/outdoor/Landscaping/Roads#Road": "Road",
 "@catalog/Other Rooms/outdoor/Landscaping/Roads#Drain": "Drain",
 "@catalog/Other Rooms/outdoor/Landscaping/Roads#Luke": "Luke",
 "@catalog/Other Rooms/outdoor/Landscaping/Fountain": "Fountain",
 "@catalog/Other Rooms/outdoor/Landscaping/Stones": "Stones",
 "@catalog/Other Rooms/outdoor/Landscaping/Garden styles": "Garden styles",
 "@catalog/Other Rooms/outdoor/Landscaping/Garden styles/Traditional Formal Garden": "Traditional Formal Garden",
 "@catalog/Other Rooms/outdoor/Landscaping/Garden styles/English Cottage Garden": "English Cottage Garden",
 "@catalog/Other Rooms/outdoor/Landscaping/Garden styles/Modern Minimalist Garden": "Minimalist Garden",
 "@catalog/Other Rooms/outdoor/Landscaping/Garden styles/Potager Garden": "Potager Garden",
 "@catalog/Other Rooms/outdoor/Landscaping/Garden styles/Asian Zen Garden": "Asian Zen Garden",
 "@catalog/Other Rooms/outdoor/Landscaping/Garden styles/Tropical Garden": "Tropical Garden",
 "@catalog/Other Rooms/outdoor/Landscaping/Garden styles/Mediterranean Garden": "Mediterranean Garden",
 "@catalog/Other Rooms/outdoor/Landscaping/Garden styles/Coastal Garden": "Coastal Garden",
 "@catalog/Other Rooms/outdoor/Landscaping/Garden styles/Woodland Garden": "Woodland Garden",
 "@catalog/Other Rooms/outdoor/Landscaping/Garden styles/Native Prairie Garden": "Native Prairie Garden",
 "@catalog/Other Rooms/outdoor/Landscaping/Garden styles/Xeriscape Garden": "Xeriscape Garden",
 "@catalog/Other Rooms/outdoor/Landscaping/Garden styles/Southwestern Desert Garden": "Southwestern Desert Garden",
 "@catalog/Other Rooms/outdoor/Landscaping/Garden Decor": "Garden Decor",
 "@catalog/Other Rooms/outdoor/Landscaping/Garden Vases": "Garden Vases",
 "@catalog/Other Rooms/outdoor/Landscaping/Sculpture": "Sculpture",
 "@catalog/Other Rooms/outdoor/Landscaping/Bridge": "Bridge",
 "@catalog/Other Rooms/homeoffice": "Home Office",
 "@catalog/Other Rooms/homeoffice/Office storage": "Office Storage",
 "@catalog/Other Rooms/homeoffice/Whiteboard": "Whiteboard",
 "@catalog/Other Rooms/garage": "Garage",
 "@catalog/Other Rooms/garage/Transport": "Transport",
 "@catalog/Other Rooms/garage/Transport/Cars": "Cars",
 "@catalog/Other Rooms/garage/Transport/Bikes": "Bikes",
 "@catalog/Other Rooms/garage/Transport/Stroller": "Stroller",
 "@catalog/Other Rooms/garage/Transport/SportTransport": "Sports Equipment",
 "@catalog/Other Rooms/garage/Garage decor": "Garage Decor",
 "@catalog/Other Rooms/laundry": "Laundry",
 "@catalog/Other Rooms/laundry/Sink": "Sink",
 "@catalog/Other Rooms/laundry/Sink#Kitchen Sinks": "Kitchen Sinks",
 "@catalog/Other Rooms/laundry/Sink#Sink cabinet": "Sink Cabinet",
 "@catalog/Other Rooms/laundry/Sink#Built-in Sink": "Built-in Sink",
 "@catalog/Other Rooms/laundry/Sink#Single Sink": "Single Sink",
 "@catalog/Other Rooms/laundry/Sink#Double Sink": "Double Sink",
 "@catalog/Other Rooms/laundry/Sink#Pedestal Sink": "Pedestal Sink",
 "@catalog/Other Rooms/laundry/Sink#Wall Sink": "Wall Sink",
 "@catalog/Other Rooms/laundry/Sink#Wall Tap": "Wall Tap",
 "@catalog/Other Rooms/laundry/Sink#Faucet": "Faucet",
 "@catalog/Other Rooms/laundry/Sink#Sink Bowl": "Sink Bowl",
 "@catalog/Other Rooms/laundry/Bath Accessories": "Bathroom Accessories",
 "@catalog/Other Rooms/laundry/Bath Accessories/Towel rack": "Towel Rack",
 "@catalog/Other Rooms/laundry/Bath Accessories/Towel rack#Towels": "Towels",
 "@catalog/Other Rooms/laundry/Bath Accessories/Towel rack#Towel racks": "Towel racks",
 "@catalog/Other Rooms/laundry/Bath Accessories/Towel rack#Towel stands": "Towel stands",
 "@catalog/Other Rooms/laundry/Bath Accessories/Bathroom Decor": "Bathroom Decor",
 "@catalog/Other Rooms/laundry/Bath Accessories/Bathroom Decor#Bathroom Decor Table Top": "Tabletop",
 "@catalog/Other Rooms/laundry/Bath Accessories/Bathroom Decor#Wall Bathroom Decor": "Wall-mounted",
 "@catalog/Other Rooms/laundry/Bath Accessories/Soap and shampoo": "Soap and Shampoo",
 "@catalog/Other Rooms/laundry/Bath Accessories/Soap and shampoo#Soaps": "Soaps",
 "@catalog/Other Rooms/laundry/Bath Accessories/Soap and shampoo#Shampoo": "Shampoo",
 "@catalog/Other Rooms/laundry/Bath Accessories/Soap and shampoo#Soap Holder": "Soap Holder",
 "@catalog/Other Rooms/laundry/Bath Accessories/Toilet Paper Holder": "Toilet Paper Holder",
 "@catalog/Other Rooms/laundry/Bath Accessories/Cosmetics": "Cosmetics",
 "@catalog/Other Rooms/laundry/Bath Accessories/Toilet Brush": "Toilet Brush",
 "@catalog/Other Rooms/laundry/Bath Accessories/Toothbrush holder": "Toothbrush holder",
 "@catalog/Other Rooms/laundry/Bath Accessories/Safety rack": "Safety rack",
 "@catalog/Other Rooms/laundry/Bath Accessories/Toilet Seat": "Toilet Seat",
 "@catalog/Other Rooms/laundry/Bath Accessories/Hair Dryers": "Hair Dryers",
 "@catalog/Other Rooms/laundry/Bath Accessories/Hand Dryers": "Hand Dryers",
 "@catalog/Other Rooms/cafe": "Cafe & Bar",
 "@catalog/Other Rooms/cafe/Cafe Furniture": "Cafe Items",
 "@catalog/Other Rooms/salon": "Beauty Salon",
 "@catalog/Other Rooms/salon/Beauty salon": "Beauty salon",
 "@catalog/Other Rooms/salon/Beauty chairs": "Beauty chairs",
 "@catalog/Other Rooms/event": "Event Hall",
 "@catalog/Other Rooms/event/Events": "Events",
 "@catalog/Decoration": "Decoration",
 "@catalog/Decoration/Plants and Vases": "Plants and Vases",
 "@catalog/Decoration/Plants and Vases/Home plants": "Home Plants",
 "@catalog/Decoration/Plants and Vases/Home plants#Table plants": "Table plants",
 "@catalog/Decoration/Plants and Vases/Home plants#Succulents": "Succulents",
 "@catalog/Decoration/Plants and Vases/Home plants#Wall-mount plants": "Wall-mount plants",
 "@catalog/Decoration/Plants and Vases/Home plants#Floor plants": "Floor plants",
 "@catalog/Decoration/Plants and Vases/Home plants#Ceiling-mount plants": "Ceiling-mount plants",
 "@catalog/Decoration/Plants and Vases/Vases": "Vases",
 "@catalog/Decoration/Plants and Vases/Vases#Table vase": "Table vase",
 "@catalog/Decoration/Plants and Vases/Vases#Floor vase": "Floor vase",
 "@catalog/Decoration/Plants and Vases/Plant stands": "Plant Stands",
 "@catalog/Decoration/Plants and Vases/Flowers": "Flowers",
 "@catalog/Decoration/Plants and Vases/Phytowall": "Phytowall",
 "@catalog/Decoration/Plants and Vases/Outdoor plants": "Outdoor Plants",
 "@catalog/Decoration/Plants and Vases/Trees": "Trees",
 "@catalog/Decoration/Plants and Vases/Bushes": "Bushes",
 "@catalog/Decoration/Wall Art": "Wall Art",
 "@catalog/Decoration/Wall Art/Pictures": "Pictures",
 "@catalog/Decoration/Wall Art/Pictures#Framed Art": "Framed Art",
 "@catalog/Decoration/Wall Art/Pictures#No Frame Art": "No Frame Wall Art",
 "@catalog/Decoration/Wall Art/Pictures#Table Frames": "Table Frames",
 "@catalog/Decoration/Wall Art/Pictures#Wall Art Set": "Wall Art Set",
 "@catalog/Decoration/Wall Art/Pictures#Classic Art": "Classic Wall Art",
 "@catalog/Decoration/Wall Art/Pictures#Photo Art": "Wall Photo",
 "@catalog/Decoration/Wall Art/Pictures#Text Art": "Text Wall Art",
 "@catalog/Decoration/Wall Art/Pictures#Kids Art": "Kids Wall Art",
 "@catalog/Decoration/Wall Art/Pictures#Round Art": "Round Wall Art",
 "@catalog/Decoration/Wall Art/Pictures#Sea Art": "Sea Wall Art",
 "@catalog/Decoration/Wall Art/Pictures#Asian Art": "Asian Wall Art",
 "@catalog/Decoration/Wall Art/Pictures#Abstract Art": "Abstract Wall Art",
 "@catalog/Decoration/Wall Art/Pictures#Modern Art": "Modern Wall Art",
 "@catalog/Decoration/Wall Art/Pictures#Oil Paintings": "Oil Paintings",
 "@catalog/Decoration/Wall Art/Pictures#Wood Art": "Wooden Wall Art",
 "@catalog/Decoration/Wall Art/Pictures#Maps": "Wall Maps",
 "@catalog/Decoration/Wall Art/Pictures#Reproductions": "Reproductions",
 "@catalog/Decoration/Wall Art/Pictures#Canvas Painting": "Canvas Painting",
 "@catalog/Decoration/Wall Art/Walldecor": "Wall Decor",
 "@catalog/Decoration/Wall Art/Posters": "Posters",
 "@catalog/Decoration/Wall Art/Posters#Celebrities": "Celebrities",
 "@catalog/Decoration/Wall Art/Posters#Movies Poster": "Movies,Shows",
 "@catalog/Decoration/Wall Art/Posters#Music Poster": "Music",
 "@catalog/Decoration/Wall Art/Posters#K-Pop Poster": "Hallyu",
 "@catalog/Decoration/Wall Art/Posters#Anime Poster": "Anime",
 "@catalog/Decoration/Wall Art/Posters#Plants Poster": "Botanical",
 "@catalog/Decoration/Wall Art/Posters#Fashion Poster": "Fashion",
 "@catalog/Decoration/Wall Art/Posters#Wildlife Poster": "Wildlife",
 "@catalog/Decoration/Wall Art/Posters#Minimalism Poster": "Minimalism",
 "@catalog/Decoration/Wall Art/Posters#Abstract Poster": "Abstract",
 "@catalog/Decoration/Wall Art/Posters#Typography Poster": "Typography",
 "@catalog/Decoration/Wall Art/Posters#Art Poster": "Art",
 "@catalog/Decoration/Wall Art/Posters#Vintage Poster": "Vintage",
 "@catalog/Decoration/Wall Art/Posters#Cartoon Poster": "Cartoon",
 "@catalog/Decoration/Wall Art/Posters#Sport Poster": "Sport",
 "@catalog/Decoration/Wall Art/Posters#Infographic": "Infographic",
 "@catalog/Decoration/Wall Art/Wall Clocks": "Wall Clocks",
 "@catalog/Decoration/Wall Art/Wall Stickers": "Wall Stickers",
 "@catalog/Decoration/Wall Art/Flags and Tapestries": "Flags and Tapestries",
 "@catalog/Decoration/Wall Art/Signboards": "Signboards",
 "@catalog/Decoration/Rugs": "Rugs",
 "@catalog/Decoration/Rugs#Regular Rug": "Carpet",
 "@catalog/Decoration/Rugs#Runner": "Runner",
 "@catalog/Decoration/Rugs#Round Rug": "Round Rug",
 "@catalog/Decoration/Rugs#Kids Rug": "Kids Rug",
 "@catalog/Decoration/Rugs#Door Mat": "Door Mat",
 "@catalog/Decoration/Rugs#Bath Mat": "Bath Mat",
 "@catalog/Decoration/Rugs#Prayer Mat": "Prayer Mat",
 "@catalog/Decoration/Rugs#Abstract Rug": "Abstract Rug",
 "@catalog/Decoration/Mirrors": "Mirrors",
 "@catalog/Decoration/Mirrors/Wall Mirrors": "Wall Mirrors",
 "@catalog/Decoration/Mirrors/Wall Mirrors#Square Mirrors": "Square Mirrors",
 "@catalog/Decoration/Mirrors/Wall Mirrors#Rectangle Mirrors": "Rectangle Mirrors",
 "@catalog/Decoration/Mirrors/Wall Mirrors#Round Mirrors": "Round Mirrors",
 "@catalog/Decoration/Mirrors/Wall Mirrors#Oval Mirrors": "Oval Mirrors",
 "@catalog/Decoration/Mirrors/Wall Mirrors#Arched Mirrors": "Arched Mirrors",
 "@catalog/Decoration/Mirrors/Wall Mirrors#Accent Mirrors": "Accent Mirrors",
 "@catalog/Decoration/Mirrors/Wall Mirrors#Kids Mirrors": "Kids Mirrors",
 "@catalog/Decoration/Mirrors/Wall Mirrors#Backlight Mirrors": "Backlight Mirrors",
 "@catalog/Decoration/Mirrors/Floor Mirrors": "Floor Mirrors",
 "@catalog/Decoration/Mirrors/Table Mirrors": "Table Mirrors",
 "@catalog/Decoration/Materials and Constructions": "Materials and Constructions",
 "@catalog/Decoration/Materials and Constructions/Materials": "Materials",
 "@catalog/Decoration/Materials and Constructions/Materials/Other": "Other",
 "@catalog/Decoration/Materials and Constructions/Materials/Wood": "Wood",
 "@catalog/Decoration/Materials and Constructions/Materials/Marble": "Marble",
 "@catalog/Decoration/Materials and Constructions/Materials/Tile": "Tile",
 "@catalog/Decoration/Materials and Constructions/Materials/Slats": "Slats",
 "@catalog/Decoration/Materials and Constructions/Materials/Fabric": "Fabric",
 "@catalog/Decoration/Materials and Constructions/Materials/Wallpapers": "Wallpaper",
 "@catalog/Decoration/Materials and Constructions/Materials/Finishes": "Finishes",
 "@catalog/Decoration/Materials and Constructions/Materials/Paneling": "Paneling",
 "@catalog/Decoration/Materials and Constructions/Materials/Parquet or Laminate": "Parquet, Laminate",
 "@catalog/Decoration/Materials and Constructions/Materials/Glass": "Glass",
 "@catalog/Decoration/Materials and Constructions/Materials/Stone": "Stone",
 "@catalog/Decoration/Materials and Constructions/Materials/Bricks": "Bricks",
 "@catalog/Decoration/Materials and Constructions/Materials/Carpet": "Carpet",
 "@catalog/Decoration/Materials and Constructions/Materials/MaterialPlants": "Plants",
 "@catalog/Decoration/Materials and Constructions/Materials/Metal": "Metal",
 "@catalog/Decoration/Materials and Constructions/Materials/Photo Wallpaper": "Photo Wallpapers",
 "@catalog/Decoration/Materials and Constructions/Materials/Ground": "Ground",
 "@catalog/Decoration/Materials and Constructions/Materials/Granite": "Granite",
 "@catalog/Decoration/Materials and Constructions/Materials/Neon": "Neon",
 "@catalog/Decoration/Materials and Constructions/Materials/Water": "Water",
 "@catalog/Decoration/Materials and Constructions/Materials/Sky": "Sky",
 "@catalog/Decoration/Materials and Constructions/Materials/Rattan": "Rattan",
 "@catalog/Decoration/Materials and Constructions/Materials/Leather": "Leather",
 "@catalog/Decoration/Materials and Constructions/Materials/Roof": "Roof",
 "@catalog/Decoration/Materials and Constructions/Materials/SciFi": "Sci-Fi",
 "@catalog/Decoration/Materials and Constructions/Columns": "Columns",
 "@catalog/Decoration/Materials and Constructions/Screens, Paravents": "Screens, Paravents",
 "@catalog/Decoration/Materials and Constructions/PlinthsAndMoldings": "Plinths and Moldings",
 "@catalog/Decoration/Materials and Constructions/PlinthsAndMoldings/Moldings": "Moldings",
 "@catalog/Decoration/Materials and Constructions/DecorCeiling": "Ceiling Decorations",
 "@catalog/Decoration/Table Decor": "Table Decor",
 "@catalog/Decoration/Table Decor/Vases": "Vases",
 "@catalog/Decoration/Table Decor/Room decor": "Decoration",
 "@catalog/Decoration/Table Decor/Candles": "Candles",
 "@catalog/Decoration/Table Decor/Statues": "Statues",
 "@catalog/Decoration/Table Decor/Tableware": "Tableware",
 "@catalog/Decoration/Table Decor/Tableware/Cups and glasses": "Cups and Glasses",
 "@catalog/Decoration/Table Decor/Tableware/Plates": "Plates",
 "@catalog/Decoration/Table Decor/Tableware/Drinks": "Drinks",
 "@catalog/Decoration/Table Decor/Tableware/Serving": "Dining Serving",
 "@catalog/Decoration/Table Decor/Tableware/Desserts": "Desserts",
 "@catalog/Decoration/Table Decor/Tableware/Food": "Meals",
 "@catalog/Decoration/Table Decor/Table Clocks": "Table Clocks",
 "@catalog/Decoration/Table Decor/Table Mirrors": "Mirrors",
 "@catalog/Decoration/Work and Study": "Work and Study",
 "@catalog/Decoration/Work and Study/Books": "Books",
 "@catalog/Decoration/Work and Study/Office Accessories": "Office Decor",
 "@catalog/Decoration/Work and Study/Memo Boards": "Memo board",
 "@catalog/Decoration/Work and Study/Clocks": "Clocks",
 "@catalog/Decoration/Work and Study/Whiteboards": "Whiteboards",
 "@catalog/Decoration/Organizers and Bins": "Organizers and Bins",
 "@catalog/Decoration/Organizers and Bins/Decorative Baskets": "Decorative Baskets",
 "@catalog/Decoration/Organizers and Bins/Trash bin": "Trash Bins",
 "@catalog/Decoration/Organizers and Bins/Storage Boxes": "Storage Boxes",
 "@catalog/Decoration/Organizers and Bins/Tray": "Trays",
 "@catalog/Decoration/Kids Decor": "Children's Decor",
 "@catalog/Decoration/Kids Decor/Toys": "Toys",
 "@catalog/Decoration/Kids Decor/KidsDecor": "Kids' decor",
 "@catalog/Decoration/Kids Decor/Kids Art": "Kids Wall Art",
 "@catalog/Decoration/Kids Decor/Kids Rugs": "Kids Rugs",
 "@catalog/Decoration/Kids Decor/Kids Mirrors": "Kids Mirrors",
 "@catalog/Decoration/Curtains and Dividers": "Curtains and Dividers",
 "@catalog/Decoration/Curtains and Dividers/CeilingCurtains": "Ceiling Curtain",
 "@catalog/Decoration/Curtains and Dividers/Window Curtains": "Window Curtains",
 "@catalog/Decoration/Curtains and Dividers/Screens, Paravents": "Screens, Paravents",
 "@catalog/Decoration/Characters and Pets": "Characters and Pets",
 "@catalog/Decoration/Characters and Pets/Pets": "Pets",
 "@catalog/Decoration/Characters and Pets/Pets#Cat": "Cat",
 "@catalog/Decoration/Characters and Pets/Pets#Dog": "Dog",
 "@catalog/Decoration/Characters and Pets/Pets#Fish": "Fish",
 "@catalog/Decoration/Characters and Pets/Pets#Other Pets": "Other Pets",
 "@catalog/Decoration/Characters and Pets/Characters": "Characters",
 "@catalog/Decoration/Characters and Pets/Characters#Men": "Men",
 "@catalog/Decoration/Characters and Pets/Characters#Women": "Women",
 "@catalog/Decoration/Characters and Pets/Characters#Kids": "Kids",
 "@catalog/Decoration/Characters and Pets/Characters#Groups": "Groups",
 "@catalog/Decoration/Characters and Pets/Characters#Special Characters": "Special",
 "@catalog/Decoration/Characters and Pets/Pet Supplies": "Pet Supplies",
 "@catalog/Decoration/Characters and Pets/Pet Supplies#Pet Bed": "Beds",
 "@catalog/Decoration/Characters and Pets/Pet Supplies#Pet House": "Pet House",
 "@catalog/Decoration/Characters and Pets/Pet Supplies#Pet Feeder": "Pet Feeder",
 "@catalog/Decoration/Characters and Pets/Pet Supplies#Pet Accessories": "Accessories",
 "@catalog/Decoration/Holiday Decor": "Holiday Decor",
 "@catalog/Decoration/Holiday Decor/Wedding": "Wedding",
 "@catalog/Decoration/Holiday Decor/Christmas": "Christmas",
 "@catalog/Decoration/Holiday Decor/Halloween": "Halloween",
 "@catalog/Storage": "Cabinets, Shelves",
 "@catalog/Storage/Wardrobe": "Wardrobe",
 "@catalog/Storage/Wardrobe#Sliding Door Wardrobe": "Sliding Door Wardrobe",
 "@catalog/Storage/Wardrobe#Clothes Rack": "Clothes Rack",
 "@catalog/Storage/Wardrobe#Wardrobe cabinet": "Wardrobe cabinet",
 "@catalog/Storage/Wardrobe#Wardrobe System": "Wardrobe System",
 "@catalog/Storage/Base Cabinets": "Kitchen Base Cabinets",
 "@catalog/Storage/Sink": "Sink",
 "@catalog/Storage/Shelving": "Shelving",
 "@catalog/Storage/Shelving#Bookshelve": "Bookshelve",
 "@catalog/Storage/Shelving#Pantry": "Pantry",
 "@catalog/Storage/Shelving#Wall pantry": "Wall pantry",
 "@catalog/Storage/Shelving#Storage rack": "Storage rack",
 "@catalog/Storage/Shelving#Corner shelves": "Corner shelves",
 "@catalog/Storage/Shelving#Ladder shelf": "Ladder shelf",
 "@catalog/Storage/Shelving#Lower Shelving": "Lower Shelving",
 "@catalog/Storage/Wall shelve": "Wall Shelve",
 "@catalog/Storage/Wall shelve#Corner shelve": "Corner Shelve",
 "@catalog/Storage/Wall shelve#Art shelve": "Art Shelve",
 "@catalog/Storage/Wall shelve#Paper shelve": "Paper shelve",
 "@catalog/Storage/Wall shelve#Square shelve": "Square Shelve",
 "@catalog/Storage/Wall shelve#Open shelve": "Open Shelve",
 "@catalog/Storage/Wall shelve#Closed shelve": "Closed Shelve",
 "@catalog/Storage/Wall shelve#Kitchen shelve": "Kitchen shelve",
 "@catalog/Storage/Wall shelve#Storage unit": "Storage unit",
 "@catalog/Storage/Kitchen Island": "Kitchen Island",
 "@catalog/Storage/TV Storage": "TV Storage",
 "@catalog/Storage/TV Storage#TV Stands": "TV Stands",
 "@catalog/Storage/TV Storage#Wall Units": "Wall Units",
 "@catalog/Storage/TV Storage#Entertainment Centers": "Entertainment Centers",
 "@catalog/Storage/Wall Cabinets": "Kitchen Wall Cabinets",
 "@catalog/Storage/Built In Storage": "Built In Storage",
 "@catalog/Storage/Dressers": "Drawers",
 "@catalog/Storage/Dressers#Drawer": "Drawer Unit",
 "@catalog/Storage/Dressers#Drawer Chest": "Chest of Drawers",
 "@catalog/Storage/Dressers#Dresser": "Dresser",
 "@catalog/Storage/CabinetsRegular": "Cabinets",
 "@catalog/Storage/CabinetsRegular#Secretary": "Secretary",
 "@catalog/Storage/CabinetsRegular#Corner cabinet Low": "Corner cabinet",
 "@catalog/Storage/CabinetsRegular#Staircase cabinet": "Staircase cabinet",
 "@catalog/Storage/Shoe storage": "Shoe Storage",
 "@catalog/Storage/Shoe storage#Shoe Rack": "Shoe Rack",
 "@catalog/Storage/Shoe storage#Shoe Benches": "Shoe Benches",
 "@catalog/Storage/Shoe storage#Shoe Tower": "Shoe Tower",
 "@catalog/Storage/Shoe storage#Mounted Unit": ">Wall Mount Unit",
 "@catalog/Storage/Shoe storage#Shoe Organizer": "Shoe Organizer",
 "@catalog/Storage/WallCabinetsRegular": "Wall Cabinets",
 "@catalog/Storage/WallCabinetsRegular#Single Door Cabinets": "Single Door",
 "@catalog/Storage/WallCabinetsRegular#Double Door Cabinets": "Double Door",
 "@catalog/Storage/WallCabinetsRegular#Glass Door Cabinets": "Glass Door",
 "@catalog/Storage/WallCabinetsRegular#Mirrored Door Cabinets": "Mirrored Door",
 "@catalog/Storage/WallCabinetsRegular#Open Shelve Cabinets": "Open Shelve",
 "@catalog/Storage/WallCabinetsRegular#Corner Cabinets": "Corner Cabinets",
 "@catalog/Storage/WallCabinetsRegular#Cabinet Sets": "Cabinet Sets",
 "@catalog/Storage/Countertops": "Countertops",
 "@catalog/Storage/Clothes": "Clothes",
 "@catalog/Storage/Clothes#Cloth": "Cloth",
 "@catalog/Storage/Clothes#Shoes": "Shoes",
 "@catalog/Storage/Clothes#Bags": "Bags",
 "@catalog/Storage/Clothes#Hats": "Hats",
 "@catalog/Storage/Clothes#Accessories": "Accessories",
 "@catalog/Storage/High Cabinets": "Kitchen High Cabinets",
 "@catalog/Storage/HighCabinetsRegular": "High cabinets",
 "@catalog/Storage/HighCabinetsRegular#Single High Cabinets": "Single High Cabinets",
 "@catalog/Storage/HighCabinetsRegular#Double High Cabinets": "Double High Cabinets",
 "@catalog/Storage/HighCabinetsRegular#Open High Cabinets": "Open High Cabinets",
 "@catalog/Storage/Tall cabinets": "Tall cabinets",
 "@catalog/Storage/Tall cabinets#Bookcase": "Bookcase",
 "@catalog/Storage/Tall cabinets#Corner cabinet High": "Corner cabinet",
 "@catalog/Storage/Coat stand": "Coat Stand",
 "@catalog/Storage/Coat stand#Free-standing": "Free-standing",
 "@catalog/Storage/Coat stand#Hallway Units": "Hallway Units",
 "@catalog/Storage/Coat stand#Umbrella Stand": "Umbrella Stand",
 "@catalog/Storage/Hanger": "Hanger",
 "@catalog/Storage/Hanger#Hooks": "Hooks",
 "@catalog/Storage/Hanger#Hook Rails": "Hook Rails",
 "@catalog/Storage/Hanger#Wall Mount Hanger": "Wall Mount Hanger",
 "@catalog/Storage/Hanger#Accent Hanger": "Accent Hanger",
 "@catalog/Storage/Moldings": "Moldings",
 "@catalog/Storage/Hutch": "Hutch",
 "@catalog/Storage/Office storage": "Office Storage",
 "@catalog/Storage/Kids Storage": "Kids Storage",
 "@catalog/Storage/Showcase": "Showcase",
 "@catalog/Storage/Locker": "Locker",
 "@catalog/Storage/Sideboards": "Sideboard",
 "@catalog/Storage/Sideboards#Sideboard": "Sideboard",
 "@catalog/Storage/Sideboards#Console Table": "Console Table",
 "@catalog/Storage/Sideboards#Credenza": "Credenza",
 "@catalog/Storage/Sideboards#Server": "Server",
 "@catalog/Storage/Sideboards#Buffet": "Buffet",
 "@catalog/Storage/Room divider": "Room Divider",
 "@catalog/Storage/Room divider#Room partition": "Room partition",
 "@catalog/Storage/Room divider#Paravent": "Paravent",
 "@catalog/Storage/Room divider#Storage partition": "Storage partition",
 "@catalog/Storage/Knobs,handles": "Knobs,Handles",
 "@catalog/Storage/Knobs,handles#Entry Locks": "Entry Locks",
 "@catalog/Storage/Knobs,handles#Door Levers": "Door Levers",
 "@catalog/Storage/Knobs,handles#Cabinet Pulls": "Cabinet Pulls",
 "@catalog/Storage/Knobs,handles#Cabinet Knobs": "Cabinet Knobs",
 "@catalog/Storage/Wine Cabinets": "Wine Cabinets",
 "@catalog/Storage/Kitchen Cart": "Kitchen Cart",
 "@catalog/TablesAndChairs": "Tables and Chairs",
 "@catalog/TablesAndChairs/Desk": "Desk",
 "@catalog/TablesAndChairs/Desk#Writing Desk": "Writing Desk",
 "@catalog/TablesAndChairs/Desk#Executive Desk": "Executive Desk",
 "@catalog/TablesAndChairs/Desk#Simple Table": "Simple Table",
 "@catalog/TablesAndChairs/Desk#Laptop Stand": "Laptop Stand",
 "@catalog/TablesAndChairs/Desk#Floating Desk": "Floating Desk",
 "@catalog/TablesAndChairs/Desk#Junior Table": "Junior Table",
 "@catalog/TablesAndChairs/Desk#Work Station": "Work Station",
 "@catalog/TablesAndChairs/Desk#Standing Desk": "Standing Desk",
 "@catalog/TablesAndChairs/Desk#Ladder Desk": "Ladder Desk",
 "@catalog/TablesAndChairs/Desk#Corner Desk": "Corner Desk",
 "@catalog/TablesAndChairs/Desk#Conference Table": "Conference Table",
 "@catalog/TablesAndChairs/Kitchen Island": "Kitchen Island",
 "@catalog/TablesAndChairs/Kitchen Island#Rectangular Island": "Rectangular Island",
 "@catalog/TablesAndChairs/Kitchen Island#Round Island": "Round Island",
 "@catalog/TablesAndChairs/Kitchen Island#Small Island": "Small Island",
 "@catalog/TablesAndChairs/Kitchen Island#Integrated Island": "Integrated Island",
 "@catalog/TablesAndChairs/Kitchen Island#Island with Shelving": "Island with Shelving",
 "@catalog/TablesAndChairs/Coffee table": "Coffee Table",
 "@catalog/TablesAndChairs/Dressing table": "Dressing Table",
 "@catalog/TablesAndChairs/Dressing table#Vanity table": "Vanity table",
 "@catalog/TablesAndChairs/Dressing table#Vanity Dressers": "Vanity Dressers",
 "@catalog/TablesAndChairs/Dressing table#Mirrored Vanities": "Mirrored Vanities",
 "@catalog/TablesAndChairs/Dressing table#Round Mirror Units": "Round Mirror Units",
 "@catalog/TablesAndChairs/Dressing table#Lighted Vanities": "Lighted Vanities",
 "@catalog/TablesAndChairs/Dressing table#Tri-fold Vanities": "Tri-fold Vanities",
 "@catalog/TablesAndChairs/Dressing table#Wall-mount Vanities": "Wall-mount Vanities",
 "@catalog/TablesAndChairs/Dining set": "Dining Set",
 "@catalog/TablesAndChairs/Dining set#Set for 2": "Set for 2",
 "@catalog/TablesAndChairs/Dining set#Set for 3": "Set for 3",
 "@catalog/TablesAndChairs/Dining set#Set for 4": "Set for 4",
 "@catalog/TablesAndChairs/Dining set#Set for 6": "Set for 6",
 "@catalog/TablesAndChairs/Dining set#Set for 8+": "Set for 8+",
 "@catalog/TablesAndChairs/DiningTables": "Dining Table",
 "@catalog/TablesAndChairs/DiningTables#Rectangle Table": "Rectangle Table",
 "@catalog/TablesAndChairs/DiningTables#Round Table": "Round Table",
 "@catalog/TablesAndChairs/DiningTables#Square Table": "Square Table",
 "@catalog/TablesAndChairs/DiningTables#Oval Table": "Oval Table",
 "@catalog/TablesAndChairs/DiningTables#Abstract Table": "Abstract Table",
 "@catalog/TablesAndChairs/DiningTables#Sliding Table": "Sliding Table",
 "@catalog/TablesAndChairs/Office Chair": "Swivel Chair",
 "@catalog/TablesAndChairs/Side table": "Side Table",
 "@catalog/TablesAndChairs/Chair": "Chair",
 "@catalog/TablesAndChairs/Chair#Non Upholstered Chair": "Non Upholstered Chair",
 "@catalog/TablesAndChairs/Chair#Upholstered Chair": "Upholstered Chair",
 "@catalog/TablesAndChairs/Chair#Folding Chair": "Folding Chair",
 "@catalog/TablesAndChairs/Chair#Conference Chair": "Conference Chair",
 "@catalog/TablesAndChairs/Chair#School Chair": "School Chair",
 "@catalog/TablesAndChairs/Chair#Tulip Chair": "Tulip Chair",
 "@catalog/TablesAndChairs/Chair#Butterfly Chair": "Butterfly Chair",
 "@catalog/TablesAndChairs/Chair#Swivel Chair": "Swivel Chair",
 "@catalog/TablesAndChairs/Chair#Care Chair": "Care Chair",
 "@catalog/TablesAndChairs/Barstool": "Barstool",
 "@catalog/TablesAndChairs/Barstool#SwivelBarstool": "SwivelBarstool",
 "@catalog/TablesAndChairs/Barstool#LowBackBarstool": "LowBackBarstool",
 "@catalog/TablesAndChairs/Barstool#FullBackBarstool": "Full-back Barstool",
 "@catalog/TablesAndChairs/Barstool#BacklessBarstool": "Backless Barstool",
 "@catalog/TablesAndChairs/Barstool#RoundBarstool": "RoundBarstool",
 "@catalog/TablesAndChairs/Stool": "Stool",
 "@catalog/TablesAndChairs/Stool#Legged Stool": "Legged Stool",
 "@catalog/TablesAndChairs/Stool#Solid Stool": "Solid Stool",
 "@catalog/TablesAndChairs/Stool#Square Stool": "Square Stool",
 "@catalog/TablesAndChairs/Stool#Round Stool": "Round Stool",
 "@catalog/TablesAndChairs/Stool#Backrest Stool": "Backrest Stool",
 "@catalog/TablesAndChairs/Stool#Upholstered Stool": "Upholstered Stool",
 "@catalog/TablesAndChairs/Stool#Accent Stool": "Accent Stool",
 "@catalog/TablesAndChairs/Bar Table": "Bar Table",
 "@catalog/TablesAndChairs/Bar Table#Rectangle Table": "Rectangle Table",
 "@catalog/TablesAndChairs/Bar Table#Round Table": "Round Table",
 "@catalog/TablesAndChairs/Bar Table#Square Table": "Square Table",
 "@catalog/TablesAndChairs/Bar Table#Oval Table": "Oval Table",
 "@catalog/TablesAndChairs/Outdoor Dining": "Outdoor Furniture",
 "@catalog/TablesAndChairs/Outdoor Dining#Outdoor Dining Set": "Outdoor Set",
 "@catalog/TablesAndChairs/Outdoor Dining#Outdoor Dining Table": "Tables",
 "@catalog/TablesAndChairs/Outdoor Dining#Outdoor Dining Chairs": "Chairs",
 "@catalog/TablesAndChairs/Reception": "Reception",
 "@catalog/TablesAndChairs/Reception#Straight Reception": "Straight Reception",
 "@catalog/TablesAndChairs/Reception#Curved Reception": "Curved Reception",
 "@catalog/TablesAndChairs/Reception#L-shape Reception": "L-shape Reception",
 "@catalog/TablesAndChairs/Reception#U-shape Reception": "U-shape Reception",
 "@catalog/TablesAndChairs/Reception#Stone Reception": "Stone Reception",
 "@catalog/TablesAndChairs/Reception#Wooden Reception": "Wooden Reception",
 "@catalog/TablesAndChairs/Kids furniture": "Kids Furniture",
 "@catalog/TablesAndChairs/Kids furniture/Kids Table Sets": "Kids Table Sets",
 "@catalog/TablesAndChairs/Kids furniture/Kids Tables": "Kids Tables",
 "@catalog/TablesAndChairs/Kids furniture/Kids Chairs": "Kids Chairs",
 "@catalog/TablesAndChairs/Kids furniture/Junior Chair": "Junior Chair",
 "@catalog/TablesAndChairs/Kids furniture/Kids Desk": "Kids Desk",
 "@catalog/TablesAndChairs/Coworking": "Coworking Seats",
 "@catalog/TablesAndChairs/Coworking#Coworking seats": "Coworking Seats",
 "@catalog/TablesAndChairs/Coworking#Cubicle": "Cubicle",
 "@catalog/TablesAndChairs/Coworking#Office Set": "Office set",
 "@catalog/TablesAndChairs/High Chair": "High Chair",
 "@catalog/TablesAndChairs/Step stool": "Step Stool",
 "@catalog/Electronic Devices": "Electronic Devices",
 "@catalog/Electronic Devices/TV / Media": "TV / Media",
 "@catalog/Electronic Devices/TV / Media/Wall TV": "Wall TV",
 "@catalog/Electronic Devices/TV / Media/TV Storage": "TV Storage",
 "@catalog/Electronic Devices/TV / Media/Table TV": "TV",
 "@catalog/Electronic Devices/TV / Media/TV set-top box": "TV Set-top Box",
 "@catalog/Electronic Devices/TV / Media/Sound": "Sound Equipment",
 "@catalog/Electronic Devices/TV / Media/Projector": "Projector",
 "@catalog/Electronic Devices/KitchenAppliances": "Kitchen Appliances",
 "@catalog/Electronic Devices/KitchenAppliances/Refrigerators": "Refrigerators",
 "@catalog/Electronic Devices/KitchenAppliances/Refrigerators#Side-by-Side Fridge": "Side-by-Side Fridge",
 "@catalog/Electronic Devices/KitchenAppliances/Refrigerators#Mini Fridge": "Mini Fridge",
 "@catalog/Electronic Devices/KitchenAppliances/Refrigerators#Top Freezer Fridge": "Top Freezer Fridge",
 "@catalog/Electronic Devices/KitchenAppliances/Refrigerators#Beverage Fridge": "Beverage Fridge",
 "@catalog/Electronic Devices/KitchenAppliances/Cooktop": "Cooktop",
 "@catalog/Electronic Devices/KitchenAppliances/Cooktop#Gas Cooktop": "Gas Cooktop",
 "@catalog/Electronic Devices/KitchenAppliances/Cooktop#Electric Cooktop": "Electric Cooktop",
 "@catalog/Electronic Devices/KitchenAppliances/Cooker Hood": "Cooker Hood",
 "@catalog/Electronic Devices/KitchenAppliances/Cooker Hood#Canopy Hood": "Canopy Hood",
 "@catalog/Electronic Devices/KitchenAppliances/Cooker Hood#T-shaped Hood": "T-shaped Hood",
 "@catalog/Electronic Devices/KitchenAppliances/Cooker Hood#Telescopic Hood": "Telescopic Hood",
 "@catalog/Electronic Devices/KitchenAppliances/Cooker Hood#Builtin Hood": "Builtin Hood",
 "@catalog/Electronic Devices/KitchenAppliances/Cooker Hood#Island Hood": "Island Hood",
 "@catalog/Electronic Devices/KitchenAppliances/Cooker Hood#Angled Hood": "Angled Hood",
 "@catalog/Electronic Devices/KitchenAppliances/Ovens": "Ovens",
 "@catalog/Electronic Devices/KitchenAppliances/Ovens#Range": "Range",
 "@catalog/Electronic Devices/KitchenAppliances/Ovens#Gas Oven": "Gas Oven",
 "@catalog/Electronic Devices/KitchenAppliances/Ovens#Electric Oven": "Electric Oven",
 "@catalog/Electronic Devices/KitchenAppliances/Ovens#Combined Oven": "Combined Oven",
 "@catalog/Electronic Devices/KitchenAppliances/Ovens#Builtin Oven": "Builtin Oven",
 "@catalog/Electronic Devices/KitchenAppliances/Coffee Maker": "Coffee Maker",
 "@catalog/Electronic Devices/KitchenAppliances/Microwave": "Microwave",
 "@catalog/Electronic Devices/KitchenAppliances/KitchenTableElectronics": "More kitchen devices",
 "@catalog/Electronic Devices/KitchenAppliances/Water purifier": "Water Purifier",
 "@catalog/Electronic Devices/KitchenAppliances/Dishwashers": "Dishwashers",
 "@catalog/Electronic Devices/KitchenAppliances/Kettle": "Kettle",
 "@catalog/Electronic Devices/KitchenAppliances/Multi cooker,Rice cooker": "Multi cooker, Rice cooker",
 "@catalog/Electronic Devices/KitchenAppliances/Toaster": "Toaster",
 "@catalog/Electronic Devices/KitchenAppliances/Blender,Mixer,Food processor": "Food processor",
 "@catalog/Electronic Devices/KitchenAppliances/Drying cabinet": "Drying Cabinet",
 "@catalog/Electronic Devices/Climate electronics": "Climate Electronics",
 "@catalog/Electronic Devices/Climate electronics/Conditioner": "Conditioner",
 "@catalog/Electronic Devices/Climate electronics/Ceiling fan": "Ceiling Fan",
 "@catalog/Electronic Devices/Climate electronics/Heating": "Heating",
 "@catalog/Electronic Devices/Climate electronics/Heating#Wall Radiator": "Wall Radiator",
 "@catalog/Electronic Devices/Climate electronics/Heating#Floor Radiator": "Floor Radiator",
 "@catalog/Electronic Devices/Climate electronics/Heating#Towel Dryer": "Towel Dryer",
 "@catalog/Electronic Devices/Climate electronics/Ventilation": "Ventilation",
 "@catalog/Electronic Devices/Climate electronics/Fan": "Fan",
 "@catalog/Electronic Devices/Climate electronics/Air purifier": "Air Purifier",
 "@catalog/Electronic Devices/Climate electronics/Water heater": "Water Heater",
 "@catalog/Electronic Devices/Climate electronics/Thermometer": "Thermometer",
 "@catalog/Electronic Devices/LightingOutletsSwitches": "Outlets, Switches",
 "@catalog/Electronic Devices/Washers / Dryers": "Washers / Dryers",
 "@catalog/Electronic Devices/Washers / Dryers#Washing Machines": "Washing Machines",
 "@catalog/Electronic Devices/Washers / Dryers#Drying Machines": "Dryers",
 "@catalog/Electronic Devices/Washers / Dryers#Top Load Washers": "Top Load Washers",
 "@catalog/Electronic Devices/Washers / Dryers#Laundry Sets": "Laundry Sets",
 "@catalog/Electronic Devices/Washers / Dryers#Clothes Drying": "Clothes Drying",
 "@catalog/Electronic Devices/Office electronics": "Office Electronics",
 "@catalog/Electronic Devices/Office electronics#Laptops": "Laptops",
 "@catalog/Electronic Devices/Office electronics#PC": "PC",
 "@catalog/Electronic Devices/Office electronics#Monitors": "Monitors",
 "@catalog/Electronic Devices/Office electronics#Keyboard": "Keyboard",
 "@catalog/Electronic Devices/Office electronics#Mouse": "Mouse",
 "@catalog/Electronic Devices/Office electronics#Printer": "Printer",
 "@catalog/Electronic Devices/Office electronics#Microphone": "Microphone",
 "@catalog/Electronic Devices/Office electronics#Headphones": "Headphones",
 "@catalog/Electronic Devices/Gaming": "Gaming",
 "@catalog/Electronic Devices/Gaming/Phones and Tablets": "Phones and Tablets",
 "@catalog/Electronic Devices/Gaming/Consoles": "Game Console",
 "@catalog/Electronic Devices/Gaming/Gaming setups": "Gaming setups",
 "@catalog/Electronic Devices/Gaming/Monitors": "Monitors",
 "@catalog/Electronic Devices/Gaming/Gaming decor": "Gaming decor",
 "@catalog/Electronic Devices/Gaming/PCs": "Computer",
 "@catalog/Electronic Devices/Gaming/Gaming desks": "Gaming desks",
 "@catalog/Electronic Devices/Gaming/Gaming audio": "Gaming Audio",
 "@catalog/Electronic Devices/Gaming/VR": "VR",
 "@catalog/Electronic Devices/Gaming/Gaming chairs": "Gaming chairs",
 "@catalog/Electronic Devices/Gaming/Laptops": "Laptops",
 "@catalog/Electronic Devices/Gaming/Keyboards,Mouses": "Keyboards,Mouses",
 "@catalog/Electronic Devices/Gaming/Keyboards,Mouses#Keyboard": "Keyboard",
 "@catalog/Electronic Devices/Gaming/Keyboards,Mouses#Mouse": "Mouse",
 "@catalog/Electronic Devices/Gaming/TV": "TV",
 "@catalog/Electronic Devices/Sound equipment": "Sound Equipment",
 "@catalog/Electronic Devices/Sound equipment#Speaker": "Speaker",
 "@catalog/Electronic Devices/Sound equipment#Smart Speaker": "Smart Speaker",
 "@catalog/Electronic Devices/Sound equipment#Microphone": "Microphone",
 "@catalog/Electronic Devices/Sound equipment#Headphones": "Headphones",
 "@catalog/Electronic Devices/Sound equipment#Recorder": "Recorder",
 "@catalog/Electronic Devices/SpecificElectronics": "More Electronics",
 "@catalog/Electronic Devices/SpecificElectronics/Intercom": "Intercom",
 "@catalog/Electronic Devices/SpecificElectronics/Security camera": "Security Camera",
 "@catalog/Electronic Devices/SpecificElectronics/Router": "Router",
 "@catalog/Electronic Devices/SpecificElectronics/HomeAppliances": "More Electronics",
 "@catalog/Electronic Devices/SpecificElectronics/Antenna": "Antenna",
 "@catalog/Electronic Devices/Phones and Tablets": "Phones and Tablets",
 "@catalog/Electronic Devices/Phones and Tablets#Phones": "Phones",
 "@catalog/Electronic Devices/Phones and Tablets#Mobile Phones": "Mobile Phones",
 "@catalog/Electronic Devices/Phones and Tablets#Tablets": "Tablets",
 "@catalog/Electronic Devices/Home care electronics": "Home Care Electronics",
 "@catalog/Electronic Devices/Home care electronics/Vacuum cleaners and mops": "Vacuum Cleaners and Mops",
 "@catalog/Electronic Devices/Home care electronics/Irons and Steamers": "Irons and Steamers",
 "@catalog/Electronic Devices/Commercial electronics": "Commercial Electronics",
 "@catalog/Electronic Devices/Commercial electronics/POS system": "POS System",
 "@catalog/Electronic Devices/Commercial electronics/Security camera": "Security Camera",
 "@catalog/Electronic Devices/Commercial electronics/Commercial items": "Commercial items",
 "@catalog/Electronic Devices/Commercial electronics/Water Cooler": "Water Cooler",
 "@catalog/Electronic Devices/Commercial electronics/Vending Machine": "Vending Machine",
 "@catalog/Seating furniture": "Seating Furniture",
 "@catalog/Seating furniture/Sofa": "Sofa",
 "@catalog/Seating furniture/Sofa#3-Seat Sofa": "3-Seat Sofa",
 "@catalog/Seating furniture/Sofa#Loveseat Sofa": "Loveseat",
 "@catalog/Seating furniture/Sofa#L-Shaped Sofa": "L-Shaped Sofa",
 "@catalog/Seating furniture/Sofa#Modular Sofa": "Modular Sofa",
 "@catalog/Seating furniture/Sofa#Chaise Lounge": "Chaise Lounge",
 "@catalog/Seating furniture/Sofa#Chesterfield Sofa": "Chesterfield Sofa",
 "@catalog/Seating furniture/Sofa#Curved Sofa": "Curved Sofa",
 "@catalog/Seating furniture/Sofa#Round Sofa": "Round Sofa",
 "@catalog/Seating furniture/Sofa#P-shaped Sofa": "P-shaped Sofa",
 "@catalog/Seating furniture/Sofa#Tuxedo Sofa": "Tuxedo Sofa",
 "@catalog/Seating furniture/Sofa#Marshmallow Sofa": "Marshmallow Sofa",
 "@catalog/Seating furniture/Sofa#Settee Sofa": "Settee Mini Sofa",
 "@catalog/Seating furniture/Sofa#Sleeper Sofa": "Sleeper Sofa",
 "@catalog/Seating furniture/Sofa#SofaBed": "Sofa bed",
 "@catalog/Seating furniture/Coffee table": "Coffee Table",
 "@catalog/Seating furniture/Coffee table#Rectangle Table": "Rectangle Table",
 "@catalog/Seating furniture/Coffee table#Round Table": "Round Table",
 "@catalog/Seating furniture/Coffee table#Square Table": "Square Table",
 "@catalog/Seating furniture/Coffee table#Oval Table": "Oval Table",
 "@catalog/Seating furniture/Coffee table#Abstract Table": "Abstract Table",
 "@catalog/Seating furniture/Coffee table#Sliding Table": "Sliding Table",
 "@catalog/Seating furniture/Armchair": "Armchair",
 "@catalog/Seating furniture/Armchair#Wingback Chair": "Wingback Chair",
 "@catalog/Seating furniture/Armchair#Barrel Chair": "Barrel Chair",
 "@catalog/Seating furniture/Armchair#Club Chair": "Club Chair",
 "@catalog/Seating furniture/Armchair#Recliner Chair": "Recliner Chair",
 "@catalog/Seating furniture/Armchair#Chesterfield Chair": "Chesterfield Chair",
 "@catalog/Seating furniture/Armchair#Accent Chair": "Accent Chair",
 "@catalog/Seating furniture/Armchair#Slipper Chair": "Slipper Chair",
 "@catalog/Seating furniture/Armchair#Armchair With Ottoman": "Armchair With Ottoman",
 "@catalog/Seating furniture/Armchair#Corner Chair": "Corner Chair",
 "@catalog/Seating furniture/Armchair#Round Chair": "Round Chair",
 "@catalog/Seating furniture/Armchair#Egg Chair": "Egg Chair",
 "@catalog/Seating furniture/Armchair#Massage Chair": "Massage Chair",
 "@catalog/Seating furniture/Office Chair": "Swivel Chair",
 "@catalog/Seating furniture/Office Chair#Gaming Chair": "Gaming Chair",
 "@catalog/Seating furniture/Office Chair#Executive Chair": "Executive Chair",
 "@catalog/Seating furniture/Office Chair#Swan Chair": "Swan Chair",
 "@catalog/Seating furniture/Side table": "Side Table",
 "@catalog/Seating furniture/Side table#Rectangle Table": "Rectangle Table",
 "@catalog/Seating furniture/Side table#Round Table": "Round Table",
 "@catalog/Seating furniture/Side table#Square Table": "Square Table",
 "@catalog/Seating furniture/Side table#Oval Table": "Oval Table",
 "@catalog/Seating furniture/Side table#Abstract Table": "Abstract Table",
 "@catalog/Seating furniture/Side table#C Table": "C-shaped Table",
 "@catalog/Seating furniture/Side table#Nesting Table": "Nesting Table",
 "@catalog/Seating furniture/Chaise": "Chaise",
 "@catalog/Seating furniture/Pouf, Footstool": "Pouf, Footstool",
 "@catalog/Seating furniture/Pouf, Footstool#Ottoman,Footstool": "Ottoman",
 "@catalog/Seating furniture/Pouf, Footstool#Round pouf": "Round pouf",
 "@catalog/Seating furniture/Pouf, Footstool#Oval pouf": "Oval pouf",
 "@catalog/Seating furniture/Pouf, Footstool#Square pouf": "Square pouf",
 "@catalog/Seating furniture/Pouf, Footstool#Rectangle pouf": "Rectangle pouf",
 "@catalog/Seating furniture/Pouf, Footstool#Abstract pouf": "Abstract pouf",
 "@catalog/Seating furniture/Pouf, Footstool#Storage pouf": "Storage pouf",
 "@catalog/Seating furniture/Pouf, Footstool#Low pouf": "Low pouf",
 "@catalog/Seating furniture/Pillow": "Pillow",
 "@catalog/Seating furniture/Bean Bag": "Bean Bag",
 "@catalog/Seating furniture/Outdoor Furniture": "Outdoor Furniture",
 "@catalog/Seating furniture/Outdoor Furniture#Conversation Set": "Conversation Set",
 "@catalog/Seating furniture/Outdoor Furniture#Outdoor Sofa": "Bench",
 "@catalog/Seating furniture/Outdoor Furniture#Outdoor Armchair": "Armchair",
 "@catalog/Seating furniture/Outdoor Furniture#Adirondack Chair": "Adirondack Chair",
 "@catalog/Seating furniture/CommercialSeating": "Commercial Furniture",
 "@catalog/Seating furniture/CommercialSeating/Cafe Seating": "Cafe Seating",
 "@catalog/Seating furniture/CommercialSeating/Waiting Room Chairs": "Waiting Room Chairs",
 "@catalog/Seating furniture/CommercialSeating/Waiting Room Chairs#1 Chair": "1-seat",
 "@catalog/Seating furniture/CommercialSeating/Waiting Room Chairs#2 Chairs": "2-seat",
 "@catalog/Seating furniture/CommercialSeating/Waiting Room Chairs#3 Chairs": "3-seat",
 "@catalog/Seating furniture/CommercialSeating/Waiting Room Chairs#3+ Chairs": "3+ seats",
 "@catalog/Seating furniture/CommercialSeating/Beauty chairs": "Beauty chairs",
 "@catalog/Seating furniture/CommercialSeating/Tribune": "Tribune",
 "@catalog/Seating furniture/CommercialSeating/Theater Chairs": "Theater Chairs",
 "@catalog/Seating furniture/CommercialSeating/Theater Chairs#1-seat": "1-seat",
 "@catalog/Seating furniture/CommercialSeating/Theater Chairs#2-seat": "2-seat",
 "@catalog/Seating furniture/CommercialSeating/Theater Chairs#3-seat": "3-seat",
 "@catalog/Seating furniture/CommercialSeating/Theater Chairs#3+ seats": "3+ seats",
 "@catalog/Seating furniture/Rocking chair": "Rocking Chair",
 "@catalog/Seating furniture/Hammock": "Hammock",
 "@catalog/Seating furniture/Hammock#Hanging Hammock": "Hanging hammock",
 "@catalog/Seating furniture/Hammock#Ceiling Hammock": "Ceiling hammock",
 "@catalog/Seating furniture/Hammock#Standing Hammock": "Standing hammock",
 "@catalog/Seating furniture/Outdoor Bench": "Outdoor Bench",
 "@catalog/Seating furniture/Outdoor Bench#Outdoor Bench Backless": "Backless outdoor bench",
 "@catalog/Seating furniture/Outdoor Bench#Backrest Outdoor Bench": "Backrest outdoor bench",
 "@catalog/Seating furniture/Outdoor Bench#Concrete Outdoor Bench": "Concrete outdoor bench",
 "@catalog/Seating furniture/Outdoor Bench#Planter Outdoor Bench": "Planter outdoor bench",
 "@catalog/Seating furniture/Outdoor Bench#Wooden Outdoor Bench": "Wooden outdoor bench",
 "@catalog/Seating furniture/Outdoor Bench#Metal Outdoor Bench": "Metal outdoor bench",
 "@catalog/Seating furniture/Outdoor Bench#Upholstered Outdoor Bench": "Upholstered outdoor bench",
 "@catalog/Seating furniture/Outdoor Bench#Abstract Outdoor Bench": "Abstract outdoor bench",
 "@catalog/Seating furniture/Outdoor Bench#Public Outdoor Bench": "Public outdoor bench",
 "@catalog/Seating furniture/Outdoor Bench#Garden Outdoor Bench": "Garden outdoor bench",
 "@catalog/Seating furniture/Sunbed": "Sunbed",
 "@catalog/Seating furniture/Sunbed#Single Sunbed": "Single sunbed",
 "@catalog/Seating furniture/Sunbed#Double Sunbed": "Double sunbed",
 "@catalog/Seating furniture/Sunbed#Upholstered Sunbed": "Upholstered sunbed",
 "@catalog/Seating furniture/Sunbed#Wooden Sunbed": "Wooden sunbed",
 "@catalog/Seating furniture/Sunbed#Plastic Sunbed": "Plastic sunbed",
 "@catalog/Seating furniture/Sunbed#Metal Sunbed": "Metal sunbed",
 "@catalog/Seating furniture/Sunbed#Rattan Sunbed": "Rattan sunbed",
 "@catalog/Seating furniture/Sunbed#Adjustable Backrest": "Adjustable backrest",
 "@catalog/Seating furniture/Swings": "Swings",
 "@catalog/Seating furniture/Swings#Standing Swings": "Standing swings",
 "@catalog/Seating furniture/Swings#Swing Chair": "Swing Chair",
 "@catalog/Seating furniture/Swings#Hanging Chair": "Hanging Chair",
 "@catalog/Seating furniture/Swings#Hanging Swings": "Hanging swings",
 "@catalog/kitchens": "Kitchen",
 "@catalog/kitchens/Kitchen collections": "Kitchen Collections",
 "@catalog/kitchens/Kitchen collections/Kitchen sets": "Kitchen Sets",
 "@catalog/kitchens/Kitchen collections/Kitchen sets#Base Only Kitchen": "Base Only Kitchen",
 "@catalog/kitchens/Kitchen collections/Kitchen sets#Straight Kitchen": "Straight Kitchen",
 "@catalog/kitchens/Kitchen collections/Kitchen sets#L-shaped kitchen": "L-shaped kitchen",
 "@catalog/kitchens/Kitchen collections/Kitchen sets#U-shaped Kitchen": "U-shaped Kitchen",
 "@catalog/kitchens/Kitchen collections/Kitchen sets#II-shaped Kitchen": "II-shaped Kitchen",
 "@catalog/kitchens/Kitchen collections/Kitchen sets#Full Wall Kitchen": "Full Wall Kitchen",
 "@catalog/kitchens/Kitchen collections/Base Cabinets": "Kitchen Base Cabinets",
 "@catalog/kitchens/Kitchen collections/Kitchen Island": "Kitchen Island",
 "@catalog/kitchens/Kitchen collections/Wall Cabinets": "Kitchen Wall Cabinets",
 "@catalog/kitchens/Kitchen collections/Kitchen High Cabinets": "Kitchen High Cabinets",
 "@catalog/kitchens/Kitchen collections/Countertops": "Countertops",
 "@catalog/kitchens/Kitchen collections/Knoxhult": "Knoxhult",
 "@catalog/kitchens/Kitchen collections/Axstad": "Axstad",
 "@catalog/kitchens/Kitchen collections/Traditional kitchen": "Traditional Kitchen",
 "@catalog/kitchens/Kitchen collections/Enhet": "Enhet",
 "@catalog/kitchens/Kitchen collections/Hittarp": "Hittarp",
 "@catalog/kitchens/Kitchenware": "Kitchenware",
 "@catalog/kitchens/Kitchenware/Kitchen decor": "Kitchen Decor",
 "@catalog/kitchens/Kitchenware/Jars and boxes": "Jars and Boxes",
 "@catalog/kitchens/Kitchenware/Cups and glasses": "Cups and Glasses",
 "@catalog/kitchens/Kitchenware/Plates": "Plates",
 "@catalog/kitchens/Kitchenware/Railings and wall storage": "Railings and Wall Storage",
 "@catalog/kitchens/Kitchenware/Ingredients": "Ingredients",
 "@catalog/kitchens/Kitchenware/Drinks": "Drinks",
 "@catalog/kitchens/Kitchenware/Cutting boards": "Cutting Boards",
 "@catalog/kitchens/Kitchenware/Serving": "Dining Serving",
 "@catalog/kitchens/Kitchenware/Desserts": "Desserts",
 "@catalog/kitchens/Kitchenware/Pans": "Pans",
 "@catalog/AllBed": "Bed",
 "@catalog/AllBed/Bed": "Bed",
 "@catalog/AllBed/Bed#TwinBed": "Single bed",
 "@catalog/AllBed/Bed#FullBed": "Full Bed",
 "@catalog/AllBed/Bed#QueenBed": "Queen Bed",
 "@catalog/AllBed/Bed#KingBed": "King Bed",
 "@catalog/AllBed/Bed#SuperKingBed": "Super King Bed",
 "@catalog/AllBed/Bed#2LevelsBed": "Bunk & Loft Beds",
 "@catalog/AllBed/Bed#LoftBed": "Loft Bed",
 "@catalog/AllBed/Bed#FourPosterBed": "Four-poster Bed",
 "@catalog/AllBed/Bed#FoldingBed": "Folding Bed",
 "@catalog/AllBed/Bed#CornerBed": "Corner Bed",
 "@catalog/AllBed/Bed#RoundBed": "Round Bed",
 "@catalog/AllBed/Bed#OttomanBed": "Ottoman bed",
 "@catalog/AllBed/Bed#StorageBed": "Storage bed",
 "@catalog/AllBed/Bed#ConvertibleBed": "Convertible bed",
 "@catalog/AllBed/Bed#PlatformBed": "Platform bed",
 "@catalog/AllBed/Bed#NoHeadboardBed": "No headboard bed",
 "@catalog/AllBed/Bed#LeggedBed": "Legged bed",
 "@catalog/AllBed/Bed#BedFrames": "Bed frames",
 "@catalog/AllBed/Bed#Daybed": "Daybed",
 "@catalog/AllBed/Bed#WallHeadboardBed": "Wall headboard bed",
 "@catalog/AllBed/Nightstand": "Nightstand",
 "@catalog/AllBed/Nightstand#Nightstand with Door": "Nightstand with door",
 "@catalog/AllBed/Nightstand#Nightstand with Drawers": "Nightstand with drawers",
 "@catalog/AllBed/Nightstand#1 Drawer Nightstand": "1 drawer nightstand",
 "@catalog/AllBed/Nightstand#Nightstand with Shelves": "Nightstand with shelves",
 "@catalog/AllBed/Nightstand#Round Nightstand": "Round nightstand",
 "@catalog/AllBed/Nightstand#Corner Nightstand": "Corner nightstand",
 "@catalog/AllBed/Nightstand#No legs Nightstand": "No legs nightstand",
 "@catalog/AllBed/Nightstand#Solid Nightstand": "Solid nightstand",
 "@catalog/AllBed/Nightstand#Wall Nightstand": "Wall-mounted nightstand",
 "@catalog/AllBed/Dressing table": "Dressing Table",
 "@catalog/AllBed/Bedding": "Bedding",
 "@catalog/AllBed/Bedding#Twin bedding": "Twin bedding",
 "@catalog/AllBed/Bedding#Queen bedding": "Queen bedding",
 "@catalog/AllBed/Bedding#King bedding": "King bedding",
 "@catalog/AllBed/Bedding#Blankets,plaids": "Blankets,plaids",
 "@catalog/AllBed/Bedding#Mattress": "Mattress",
 "@catalog/AllBed/Bedding#Baby bedding": "Baby bedding",
 "@catalog/AllBed/KidBed": "Junior Bed",
 "@catalog/AllBed/KidBed#TwinBed": "Single bed",
 "@catalog/AllBed/KidBed#DoubleBed": "Double Bed",
 "@catalog/AllBed/KidBed#StorageBed": "Storage bed",
 "@catalog/AllBed/KidBed#Car Bed": "Car Bed",
 "@catalog/AllBed/KidBed#2 kids Bed": "2 kids Bed",
 "@catalog/AllBed/KidBed#Multitask Bed Zone": "Multitask Bed Zone",
 "@catalog/AllBed/KidBed#House Bed": "House Bed",
 "@catalog/AllBed/Pillow": "Pillow",
 "@catalog/AllBed/Pillow#Square pillow": "Square pillow",
 "@catalog/AllBed/Pillow#Round pillow": "Round pillow",
 "@catalog/AllBed/Pillow#Rectangle pillow": "Rectangle pillow",
 "@catalog/AllBed/Pillow#Abstract pillow": "Abstract pillow",
 "@catalog/AllBed/Pillow#Pillow set": "Pillow set",
 "@catalog/AllBed/Pillow#Sleep pillow": "Sleep pillow",
 "@catalog/AllBed/Pillow#Roll pillow": "Roll pillow",
 "@catalog/AllBed/Pillow#Orthopedic pillow": "Orthopedic pillow",
 "@catalog/AllBed/Pillow#Knot pillow": "Knot pillow",
 "@catalog/AllBed/Pillow#Seat pillow": "Seat pillow",
 "@catalog/AllBed/Bed End Bench": "Bed End Bench",
 "@catalog/AllBed/Bed End Bench#Storage Bench": "Storage bench",
 "@catalog/AllBed/Bed End Bench#Wooden Bench": "Wooden bench",
 "@catalog/AllBed/Bed End Bench#Upholstered Bench": "Upholstered bench",
 "@catalog/AllBed/Bed End Bench#Oval Bench": "Oval bench",
 "@catalog/AllBed/Bed End Bench#Bench with Armrests": "Bench with armrests",
 "@catalog/AllBed/Bed End Bench#Bench with Back": "Bench with back",
 "@catalog/AllBed/Bed End Bench#Bench with Shelve": "Bench with shelve",
 "@catalog/AllBed/Headboard": "Headboard",
 "@catalog/AllBed/Headboard#Upholstered headboard": "Upholstered headboard",
 "@catalog/AllBed/Headboard#Wooden headboard": "Wooden headboard",
 "@catalog/AllBed/Headboard#Rattan headboard": "Rattan headboard",
 "@catalog/AllBed/Headboard#Storage headboard": "Storage headboard",
 "@catalog/AllBed/Headboard#Lighted headboard": "Lighted headboard",
 "@catalog/AllBed/Headboard#Legged headboard": "Legged headboard",
 "@catalog/AllBed/Headboard#Solid headboard": "Solid headboard",
 "@catalog/AllBed/Crib": "Crib",
 "@catalog/AllBed/Crib#Standard crib": "Standard crib",
 "@catalog/AllBed/Crib#Convertible crib": "Convertible crib",
 "@catalog/AllBed/Crib#Rattan crib": "Rattan crib",
 "@catalog/AllBed/Crib#Mesh crib": "Mesh crib",
 "@catalog/AllBed/Crib#Cradle": "Cradle",
 "@catalog/AllBed/Crib#Storage crib": "Storage crib",
 "@catalog/AllBed/Crib#Oval crib": "Oval crib",
 "@catalog/AllBed/Crib#Crib decor": "Crib decor",
 "@catalog/AllBed/Bed Canopy": "Bed Canopy",
 "@catalog/Lighting": "Lighting",
 "@catalog/Lighting/Ceiling Lighting": "Ceiling Lighting",
 "@catalog/Lighting/Ceiling Lighting#Chandelier": "Chandelier",
 "@catalog/Lighting/Ceiling Lighting#Pendant Lamps": "Pendant Lamps",
 "@catalog/Lighting/Ceiling Lighting#Track Lights": "Track Lights",
 "@catalog/Lighting/Ceiling Lighting#Flush Mount Lights": "Flush Mount Lights",
 "@catalog/Lighting/Ceiling Lighting#Semi Flush Mount Lights": "Semi Flush Mount Lights",
 "@catalog/Lighting/Ceiling Lighting#Direct and Spot Lights": "Direct and Spot Lights",
 "@catalog/Lighting/Ceiling Lighting#Telescopic Lamps": "Telescopic Lamps",
 "@catalog/Lighting/Ceiling Lighting#Kitchen Island Lighting": "Kitchen Island Lighting",
 "@catalog/Lighting/Ceiling Lighting#Raindrop Lamps": "Raindrop Lamps",
 "@catalog/Lighting/Ceiling Lighting#Classic Lamps": "Classic Lamps",
 "@catalog/Lighting/Ceiling Lighting#LED Lighting": "LED Lighting",
 "@catalog/Lighting/LightingOutletsSwitches": "Outlets, Switches",
 "@catalog/Lighting/LightingOutletsSwitches#Switches": "Switches",
 "@catalog/Lighting/LightingOutletsSwitches#Outlets": "Outlets",
 "@catalog/Lighting/LightingOutletsSwitches#SwitchesOutlets": "Combination",
 "@catalog/Lighting/Table Lamp": "Table Lamp",
 "@catalog/Lighting/Table Lamp#Desk Lamp": "Desk Lamp",
 "@catalog/Lighting/Table Lamp#Bedside Lamp": "Bedside Lamp",
 "@catalog/Lighting/Table Lamp#Arched Lamp": "Arched Lamp",
 "@catalog/Lighting/Table Lamp#Accent Lamp": "Accent Lamp",
 "@catalog/Lighting/Table Lamp#Buffet Lamp": "Buffet Lamp",
 "@catalog/Lighting/Floor Lamp": "Floor Lamp",
 "@catalog/Lighting/Floor Lamp#Arc Floor Lamp": "Arc Floor Lamp",
 "@catalog/Lighting/Floor Lamp#Console Floor Lamp": "Console Floor Lamp",
 "@catalog/Lighting/Floor Lamp#Torchiere Floor Lamp": "Torchiere Floor Lamp",
 "@catalog/Lighting/Floor Lamp#Multiple Floor Lamp": "Multiple Floor Lamp",
 "@catalog/Lighting/Floor Lamp#StudioLight": "StudioLight",
 "@catalog/Lighting/Wall Sconce": "Wall Sconce",
 "@catalog/Lighting/Wall Sconce#Armed Lamp": "Armed Lamp",
 "@catalog/Lighting/Wall Sconce#Swing Arm Lamp": "Swing Arm Lamp",
 "@catalog/Lighting/Wall Sconce#Flush-mount Lamp": "Flush-mount Lamp",
 "@catalog/Lighting/Wall Sconce#Candle Lamp": "Candle Lamp",
 "@catalog/Lighting/Wall Sconce#Recessed Step Lamp": "Recessed Step Lamp",
 "@catalog/Lighting/Wall Sconce#Wallchiere": "Wallchiere",
 "@catalog/Lighting/Wall Sconce#Spotlight Lamp": "Spotlight Lamp",
 "@catalog/Lighting/Wall Sconce#Barn Lamp": "Barn Lamp",
 "@catalog/Lighting/Wall Sconce#Half Moon Lamp": "Half Moon Lamp",
 "@catalog/Lighting/Wall Sconce#Under Cabinet Light": "Under Cabinet Light",
 "@catalog/Lighting/Wall Sconce#Vanity Lamp": "Vanity Lamp",
 "@catalog/Lighting/Wall Sconce#Picture Lamp": "Picture Lamp",
 "@catalog/Lighting/Wall Sconce#Track Lamp": "Track Lamp",
 "@catalog/Lighting/Wall Sconce#Neon Lamp": "Neon Lamp",
 "@catalog/Lighting/Wall Sconce#Corner Wall Lamp": "Corner Wall Lamp",
 "@catalog/Lighting/Wall Sconce#Saber Wall Light": "Saber sconce",
 "@catalog/Lighting/Wall Sconce#Double Wall Lamp": "Double sconce",
 "@catalog/Lighting/Wall Sconce#Multi Wall Lamp": "Multi-lite sconce",
 "@catalog/Lighting/Wall Sconce#Accent Wall Lamp": "Accent sconce",
 "@catalog/Lighting/Wall Sconce#Wired Wall Lamp": "Sconce on wires",
 "@catalog/Lighting/Technical Lighting": "Technical Lighting",
 "@catalog/Lighting/LED backlight": "LED Backlight",
 "@catalog/Lighting/Light Garland": "Light Garland",
 "@catalog/Lighting/Ceiling fan": "Ceiling Fan",
 "@catalog/Lighting/Kid Lamp": "Kid Lamp",
 "@catalog/Lighting/Outdoor Lighting": "Outdoor Lighting",
 "@catalog/Lighting/Outdoor Lighting#Roadway lights": "Roadway lights",
 "@catalog/Lighting/Outdoor Lighting#Ground lights": "Ground lights",
 "@catalog/Lighting/Outdoor Lighting#Lantern": "Lantern",
 "@catalog/HobbyAndEntertainment": "Hobby and Entertainment",
 "@catalog/HobbyAndEntertainment/Sound equipment": "Sound Equipment",
 "@catalog/HobbyAndEntertainment/Sport Equipment": "Sports Equipment",
 "@catalog/HobbyAndEntertainment/Musical instruments": "Musical Instruments",
 "@catalog/HobbyAndEntertainment/Musical instruments#Keyboard instruments": "Keyboard instruments",
 "@catalog/HobbyAndEntertainment/Musical instruments#String instruments": "String instruments",
 "@catalog/HobbyAndEntertainment/Musical instruments#Other instruments": "Other instruments",
 "@catalog/HobbyAndEntertainment/Movies and games": "Movies and Games",
 "@catalog/HobbyAndEntertainment/Movies and games#Movies": "Movies",
 "@catalog/HobbyAndEntertainment/Movies and games#Gaming": "Gaming",
 "@catalog/HobbyAndEntertainment/More Hobby": "More Hobby",
 "@catalog/HobbyAndEntertainment/Playground": "Playground",
 "@catalog/HobbyAndEntertainment/Game table": "Game Table",
 "@catalog/HobbyAndEntertainment/Art equipment": "Art Equipment",
 "@catalog/HobbyAndEntertainment/Dance": "Dance",
 "@catalog/HobbyAndEntertainment/Events": "Events",
 "@catalog/HobbyAndEntertainment/Events#Stage": "Stage",
 "@catalog/HobbyAndEntertainment/Photo and video": "Photo and Video",
 "@catalog/HobbyAndEntertainment/Workshop equipment": "Workshop Equipment",
 "@catalog/HobbyAndEntertainment/Grill": "Grill",
 "@catalog/HobbyAndEntertainment/Sewing": "Sewing",
 "@catalog/HobbyAndEntertainment/Garden tools": "Garden Tools",
 "@catalog/Special": "More",
 "@catalog/Special/Categories": "Categories",
 "@catalog/Special/Categories/Styles": "Styles",
 "@catalog/Special/Categories/Styles/Classic": "Classic",
 "@catalog/Special/Categories/Styles/Contemporary": "Contemporary",
 "@catalog/Special/Categories/Styles/Shabby Chic": "Shabby Chic",
 "@catalog/Special/Categories/Styles/Boho": "Boho",
 "@catalog/Special/Categories/Styles/Memphis": "Memphis",
 "@catalog/Special/Categories/Styles/Scandinavian": "Scandinavian",
 "@catalog/Special/Categories/Styles/Coastal,Beach": "Coastal, Beach",
 "@catalog/Special/Categories/Styles/Victorian": "Victorian",
 "@catalog/Special/Categories/Styles/Industrial": "Industrial",
 "@catalog/Special/Categories/Styles/Rustic,Farmhouse": "Rustic, Farmhouse",
 "@catalog/Special/Categories/Styles/Transitional": "Transitional",
 "@catalog/Special/Categories/Styles/Wabi-sabi": "Wabi-sabi",
 "@catalog/Special/Categories/Styles/Neoclassic": "Neoclassic",
 "@catalog/Special/Categories/Styles/Retro": "Retro",
 "@catalog/Special/Categories/Styles/70s": "70s",
 "@catalog/Special/Categories/Styles/Mediterranean": "Mediterranean",
 "@catalog/Special/Categories/Styles/Oriental, Asian": "Oriental, Asian",
 "@catalog/Special/Categories/Styles/Craftsman": "Craftsman",
 "@catalog/Special/Categories/Styles/Tropical": "Tropical",
 "@catalog/Special/Categories/Styles/Mid-century Modern": "Mid-century Modern",
 "@catalog/Special/Categories/Styles/Eclectic": "Eclectic",
 "@catalog/Special/Categories/Styles/Southwestern": "Southwestern",
 "@catalog/Special/Categories/Collections": "Themes",
 "@catalog/Special/Categories/Collections/Thanksgiving": "Thanksgiving",
 "@catalog/Special/Categories/Collections/Events": "Events",
 "@catalog/Special/Categories/Collections/Events#Stage": "Stage",
 "@catalog/Special/Categories/Collections/Wedding": "Wedding",
 "@catalog/Special/Categories/Collections/Christmas": "Christmas",
 "@catalog/Special/Categories/Collections/Halloween": "Halloween",
 "@catalog/Special/Categories/Collections/Beauty salon": "Beauty salon",
 "@catalog/Special/Categories/Collections/Barbie": "Barbie",
 "@catalog/Special/Categories/Collections/Tiny house": "Tiny House",
 "@catalog/Special/Categories/Collections/GoToSchool": "Back To School",
 "@catalog/Special/Categories/Collections/Cottagecore": "Cottagecore",
 "@catalog/Special/Categories/Collections/Smart Home": "Smart Home",
 "@catalog/Special/Categories/Collections/Hospital": "Hospital",
 "@catalog/Special/Categories/Collections/SummerFreshness": "Summer Freshness",
 "@catalog/Special/Categories/Collections/Underwater": "Underwater",
 "@catalog/Special/Categories/Collections/Dark Academia": "Dark Academia",
 "@catalog/Special/Categories/Collections/ValentinesDay": "Valentine's Day",
 "@catalog/Special/Categories/Collections/Medieval castle": "Medieval Castle",
 "@catalog/Special/Categories/Collections/SpringBlossom": "Spring Blossom",
 "@catalog/Special/Categories/Collections/Church": "Church",
 "@catalog/Special/Categories/Collections/Ghost house": "Ghost House",
 "@catalog/Special/Categories/Collections/EidMubarak": "Eid Mubarak",
 "@catalog/Special/Categories/Collections/Wild West": "Wild West",
 "@catalog/Special/Categories/Collections/Space Odyssey": "Space Odyssey",
 "@catalog/Special/Categories/Collections/MardiGras": "Mardi Gras",
 "@catalog/Special/Categories/Collections/WinterWonderland": "Winter Wonderland",
 "@catalog/Special/Categories/Collections/Pirates": "Pirates",
 "@catalog/Special/Categories/Collections/StPatricksDay": "St. Patrick's Day",
 "@catalog/Special/Categories/Brands": "Brands",
 "@catalog/Special/Categories/Brands/IKEA": "IKEA",
 "@catalog/Special/Categories/Brands/IKEA/Knoxhult": "Knoxhult",
 "@catalog/Special/Categories/Brands/IKEA/Enhet": "Enhet",
 "@catalog/Special/Categories/Brands/IKEA/Sektion": "Sektion",
 "@catalog/Special/Categories/Brands/IKEA/All IKEA": "All IKEA",
 "@catalog/Special/Categories/Brands/IKEA/Hemnes": "Hemnes",
 "@catalog/Special/Categories/Brands/IKEA/Pax": "Pax",
 "@catalog/Special/Categories/Brands/IKEA/Billy": "Billy",
 "@catalog/Special/Categories/Brands/IKEA/Malm": "Malm",
 "@catalog/Special/Categories/Brands/IKEA/Kallax": "Kallax",
 "@catalog/Special/Categories/Brands/IKEA/Grönlid": "Grönlid",
 "@catalog/Special/Categories/Brands/IKEA/Platsa": "Platsa",
 "@catalog/Special/Categories/Brands/IKEA/Alex / Linnmon": "Alex / Linnmon",
 "@catalog/Special/Categories/Brands/IKEA/Brimnes": "Brimnes",
 "@catalog/Special/Categories/Brands/IKEA/Eket": "Eket",
 "@catalog/Special/Categories/Brands/IKEA/Besta": "Bestå",
 "@catalog/Special/Categories/Brands/IKEA/Ektorp": "Ektorp",
 "@catalog/Special/Categories/Brands/IKEA/Lidhult": "Lidhult",
 "@catalog/Special/Categories/Brands/IKEA/Mandal": "Mandal",
 "@catalog/Special/Categories/Brands/IKEA/Tyssedal": "Tyssedal",
 "@catalog/Special/Categories/Brands/IKEA/Vimle": "Vimle",
 "@catalog/Special/Categories/Brands/IKEA/Liatorp": "Liatorp",
 "@catalog/Special/Categories/Brands/IKEA/Kleppstad": "Kleppstad",
 "@catalog/Special/Categories/Brands/IKEA/Bjorksta": "Bjorksta",
 "@catalog/Special/Categories/Brands/IKEA/Lommarp": "Lommarp",
 "@catalog/Special/Categories/Brands/IKEA/Lagan": "Lagan",
 "@catalog/Special/Categories/Brands/IKEA/Havsta": "Havsta",
 "@catalog/Special/Categories/Brands/IKEA/Karlstad": "Karlstad",
 "@catalog/Special/Categories/Brands/IKEA/Sundvik": "Sundvik",
 "@catalog/Special/Categories/Brands/IKEA/Backsälen": "Backsälen",
 "@catalog/Special/Categories/Brands/IKEA/Bekant": "Bekant",
 "@catalog/Special/Categories/Brands/IKEA/Gursken": "Gursken",
 "@catalog/Special/Categories/Brands/IKEA/Elvarli": "Elvarli",
 "@catalog/Special/Categories/Brands/IKEA/Bjursta": "Bjursta",
 "@catalog/Special/Categories/Brands/IKEA/Kivik": "Kivik",
 "@catalog/Special/Categories/Brands/IKEA/Rågrund": "Rågrund",
 "@catalog/Special/Categories/Brands/IKEA/Songesand": "Songesand",
 "@catalog/Special/Categories/Brands/IKEA/Finnala": "Finnala",
 "@catalog/Special/Categories/Brands/IKEA/Friheten": "Friheten",
 "@catalog/Special/Categories/Brands/IKEA/Lack": "Lack",
 "@catalog/Special/Categories/Brands/IKEA/Lycksele": "Lycksele",
 "@catalog/Special/Categories/Brands/IKEA/Ekedalen": "Ekedalen",
 "@catalog/Special/Categories/Brands/IKEA/Nordli": "Nordli",
 "@catalog/Special/Categories/Brands/IKEA/Micke": "Micke",
 "@catalog/Special/Categories/Brands/IKEA/Tullsta": "Tullsta",
 "@catalog/Special/Categories/Brands/IKEA/Satsumas": "Satsumas",
 "@catalog/Special/Categories/Brands/IKEA/Stockholm": "Stockholm",
 "@catalog/Special/Categories/Brands/IKEA/Äpplaryd": "Äpplaryd",
 "@catalog/Special/Categories/Brands/IKEA/Färlöv": "Färlöv",
 "@catalog/Special/Categories/Brands/IKEA/Isala": "Isala",
 "@catalog/Special/Categories/Brands/IKEA/Nikkeby": "Nikkeby",
 "@catalog/Special/Categories/Brands/IKEA/Släkt": "Släkt",
 "@catalog/Special/Categories/Brands/IKEA/Vihals": "Vihals",
 "@catalog/Special/Categories/Brands/IKEA/Pjatteryd": "Pjatteryd",
 "@catalog/Special/Categories/Brands/IKEA/Arkelstorp": "Arkelstorp",
 "@catalog/Special/Categories/Brands/IKEA/Smastad": "Smastad",
 "@catalog/Special/Categories/Brands/IKEA/Odda": "Odda",
 "@catalog/Special/Categories/Brands/IKEA/Hauga": "Hauga",
 "@catalog/Special/Categories/Brands/IKEA/Härlanda": "Härlanda",
 "@catalog/Special/Categories/Brands/IKEA/Regissör": "Regissör",
 "@catalog/Special/Categories/Brands/IKEA/Holmsund": "Holmsund",
 "@catalog/Special/Categories/Brands/IKEA/Nordviken": "Nordviken",
 "@catalog/Special/Categories/Brands/IKEA/Trofast": "Trofast",
 "@catalog/Special/Categories/Brands/IKEA/Fjällbo": "Fjällbo",
 "@catalog/Special/Categories/Brands/IKEA/Idanäs": "Idanäs",
 "@catalog/Special/Categories/Brands/IKEA/Långfjäll": "Långfjäll",
 "@catalog/Special/Categories/Brands/IKEA/Simrishamn": "Simrishamn",
 "@catalog/Special/Categories/Brands/IKEA/Tornviken": "Tornviken",
 "@catalog/Special/Categories/Brands/IKEA/Vadholma": "Vadholma",
 "@catalog/Special/Categories/Brands/IKEA/Vallentuna": "Vallentuna",
 "@catalog/Special/Categories/Brands/IKEA/Trotten": "Trotten",
 "@catalog/Special/Categories/Brands/IKEA/Valje": "Valje",
 "@catalog/Special/Categories/Brands/IKEA/Nymåne": "Nymåne",
 "@catalog/Special/Categories/Brands/IKEA/Varde": "Varde",
 "@catalog/Special/Categories/Brands/IKEA/Baggebo": "Baggebo",
 "@catalog/Special/Categories/Brands/IKEA/Busunge": "Busunge",
 "@catalog/Special/Categories/Brands/IKEA/Lixhult": "Lixhult",
 "@catalog/Special/Categories/Brands/IKEA/Godmorgon": "Godmorgon",
 "@catalog/Special/Categories/Brands/IKEA/Ivar": "Ivar",
 "@catalog/Special/Categories/Brands/IKEA/Stuva": "Stuva",
 "@catalog/Special/Categories/Brands/IKEA/Mammut": "Mammut",
 "@catalog/Special/Categories/Brands/IKEA/Pinnig": "Pinnig",
 "@catalog/Special/Categories/Brands/IKEA/Vinliden": "Vinliden",
 "@catalog/Special/Categories/Brands/IKEA/Morabo": "Morabo",
 "@catalog/Special/Categories/Brands/IKEA/Stocksund": "Stocksund",
 "@catalog/Special/Categories/Brands/IKEA/Norden": "Norden",
 "@catalog/Special/Categories/Brands/IKEA/Nävlinge": "Nävlinge",
 "@catalog/Special/Categories/Brands/IKEA/Pärup": "Pärup",
 "@catalog/Special/Categories/Brands/IKEA/Sniglar": "Sniglar",
 "@catalog/Special/Categories/Brands/IKEA/Stenstorp": "Stenstorp",
 "@catalog/Special/Categories/Brands/IKEA/Söderhamn": "Söderhamn",
 "@catalog/Special/Categories/Brands/IKEA/Torparö": "Torparö",
 "@catalog/Special/Categories/Brands/IKEA/Klippan": "Klippan",
 "@catalog/Special/Categories/Brands/IKEA/Råvaror": "Råvaror",
 "@catalog/Special/Categories/Brands/IKEA/Mackapär": "Mackapär",
 "@catalog/Special/Categories/Brands/IKEA/Strandmon": "Strandmon",
 "@catalog/Special/Categories/Brands/IKEA/Ranarp": "Ranarp",
 "@catalog/Special/Categories/Brands/IKEA/Skurup": "Skurup",
 "@catalog/Special/Categories/Brands/IKEA/Sollerön": "Sollerön",
 "@catalog/Special/Categories/Brands/IKEA/Kvart": "Kvart",
 "@catalog/Special/Categories/Brands/IKEA/Rönnskär": "Rönnskär",
 "@catalog/Special/Categories/Brands/IKEA/Sandsberg": "Sandsberg",
 "@catalog/Special/Categories/Brands/IKEA/Ingatorp": "Ingatorp",
 "@catalog/Special/Categories/Brands/IKEA/Nordkisa": "Nordkisa",
 "@catalog/Special/Categories/Brands/IKEA/Nyhamn": "Nyhamn",
 "@catalog/Special/Categories/Brands/IKEA/Bondholmen": "Bondholmen",
 "@catalog/Special/Categories/Brands/IKEA/Vittsjö": "Vittsjö",
 "@catalog/Special/Categories/Brands/IKEA/Hektar": "Hektar",
 "@catalog/Special/Categories/Brands/IKEA/Ingolf": "Ingolf",
 "@catalog/Special/Categories/Brands/IKEA/Askholmen": "Askholmen",
 "@catalog/Special/Categories/Brands/IKEA/Galant": "Galant",
 "@catalog/Special/Categories/Brands/IKEA/Havsten": "Havsten",
 "@catalog/Special/Categories/Brands/IKEA/Koarp": "Koarp",
 "@catalog/Special/Categories/Brands/IKEA/Lisabo": "Lisabo",
 "@catalog/Special/Categories/Brands/IKEA/Lantliv": "Lantliv",
 "@catalog/Special/Categories/Brands/IKEA/Flottebo": "Flottebo",
 "@catalog/Special/Categories/Brands/IKEA/Rönninge": "Rönninge",
 "@catalog/Special/Categories/Brands/IKEA/Äpplarö": "Äpplarö",
 "@catalog/Special/Categories/Brands/IKEA/Uppspel": "Uppspel",
 "@catalog/Special/Categories/Brands/IKEA/Själland": "Själland",
 "@catalog/Special/Categories/Brands/IKEA/Tjusig": "Tjusig",
 "@catalog/Special/Categories/Brands/IKEA/Läckö": "Läckö",
 "@catalog/Special/Categories/Brands/IKEA/Bergmund": "Bergmund",
 "@catalog/Special/Categories/Brands/IKEA/Jutholmen": "Jutholmen",
 "@catalog/Special/Categories/Sandbox": "Archive",
 "@catalog/Special/Annotations": "Annotations",
 "@material/Bricks": "Bricks",
 "@material/Metal": "Metal",
 "@material/Tile": "Tile",
 "@material/Marble": "Marble",
 "@material/Granite": "Granite",
 "@material/Stone": "Stone",
 "@material/MaterialPlants": "Plants",
 "@material/Ground": "Ground",
 "@material/Roof": "Roof",
 "@material/Carpet": "Carpet",
 "@material/Parquet or Laminate": "Parquet, Laminate",
 "@material/Wallpapers": "Wallpaper",
 "@material/Paneling": "Paneling",
 "@material/Slats": "Slats",
 "@material/Wood": "Wood",
 "@material/Finishes": "Finishes",
 "@material/Leather": "Leather",
 "@material/Rattan": "Rattan",
 "@material/Fabric": "Fabric",
 "@material/Photo Wallpaper": "Photo Wallpapers",
 "@material/Water": "Water",
 "@material/Neon": "Neon",
 "@material/Glass": "Glass",
 "@material/Sky": "Sky",
 "@material/Other": "Other"
}
